<template>
  <div id="questionsCustom">
    <div class="margin-subpages">
      <div class="flex-row-between">
        <div class="flex-center">
          <el-input
            class="input-style"
            style="width: 240px !important;"
            autosize
            :placeholder="$t('questions.Search')"
            v-model="inputSearch"
            clearable
          ></el-input>
          <div
            class="flex-center drop-down-container ml-auto"
            :class="`${questionFilterList.length > 0 ? 'active' : ''}`"
          >
            <el-dropdown
              trigger="click"
              :hide-on-click="false"
              ref="dropdownValuesMenu"
            >
              <div class="text-drop-down flex-mid">
                <span v-if="questionFilterList.length > 0">
                  ({{ questionFilterList.length }})&nbsp;
                </span>
                <div>Question Type</div>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownHeader">
                  <div>
                    <el-button
                      @click="handleSelectAllQuestionType"
                      class="dropdownHeaderTextStyle"
                      type="text"
                      >{{ $t("powerUp.Select_all") }}</el-button
                    >
                    <el-button
                      @click="checkedQuestionType = []"
                      class="dropdownHeaderTextStyle"
                      style="margin-left: 24px"
                      type="text"
                      >{{ $t("powerUp.Clear") }}</el-button
                    >
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div class="tooltipStyle" slot="content">
                      Filter by the type of question that is delivered as part
                      of the daily check-ins
                    </div>
                    <div class="flex-center">
                      <img
                        :src="$utils('icons', 'ic_help_outline-16px')"
                        alt="icons_ic_help_outline-16px"
                      />
                    </div>
                  </el-tooltip>
                </div>
                <div class="dropdownItem-tabActivity thin-scrollbar">
                  <el-checkbox-group v-model="checkedQuestionType">
                    <el-dropdown-item
                      v-for="item in questionTypeOption"
                      :key="item.type"
                    >
                      <el-checkbox :label="item.type" :key="item.type">{{
                        item.type
                      }}</el-checkbox>
                    </el-dropdown-item>
                  </el-checkbox-group>
                </div>
                <div class="dropdownFooter">
                  <el-button @click="clearQuestionTypeSelected" type="cancel">{{
                    $t("powerUp.Cancel")
                  }}</el-button>
                  <el-button @click="saveQuestionTypeFiltered" type="save">{{
                    $t("powerUp.Okay")
                  }}</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <div
              v-if="questionFilterList.length > 0"
              class="relative"
              style="width: 26px"
            >
              <div
                @click="(checkedQuestionType = []), saveQuestionTypeFiltered()"
                class="drop-down-close"
              >
                <div class="x-btn"></div>
              </div>
            </div>
          </div>
          <div class="flex-center drop-down-container" :class="`${dimensionFilterList.length > 0 ? 'active' : ''}`">
            <el-dropdown trigger="click" :hide-on-click="false" ref="dropdownDimension">
              <div class="text-drop-down flex-mid">
                <span v-if="dimensionFilterList.length > 0">
                  ({{ dimensionFilterList.length }})&nbsp;
                </span>
                <div>Dimension</div>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownHeader">
                  <div>
                    <el-button @click="handleSelectAllDimension" class="dropdownHeaderTextStyle" type="text">{{
                      $t("powerUp.Select_all") }}</el-button>
                    <el-button @click="checkedDimension = []" class="dropdownHeaderTextStyle" style="margin-left: 24px"
                      type="text">{{ $t("powerUp.Clear") }}</el-button>
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div class="tooltipStyle" slot="content">
                      Filter by the dimension of question that is delivered as part of the daily check-ins
                    </div>
                    <div class="flex-center">
                      <img :src="$utils('icons', 'ic_help_outline-16px')" alt="icons_ic_help_outline-16px" />
                    </div>
                  </el-tooltip>
                </div>
                <div class="dropdownItem-tabActivity thin-scrollbar">
                  <el-checkbox-group v-model="checkedDimension">
                    <el-dropdown-item v-for="item in dimensionOption" :key="item.type">
                      <el-checkbox :label="item.type" :key="item.type">{{
                        item.type
                      }}</el-checkbox>
                    </el-dropdown-item>
                  </el-checkbox-group>
                </div>
                <div class="dropdownFooter">
                  <el-button @click="clearDimensionSelected" type="cancel">{{
                    $t("powerUp.Cancel")
                  }}</el-button>
                  <el-button @click="saveDimensionFiltered" type="save">{{
                    $t("powerUp.Okay")
                  }}</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-if="dimensionFilterList.length > 0" class="relative" style="width: 26px">
              <div @click="checkedDimension = [], saveDimensionFiltered()" class="drop-down-close">
                <div class="x-btn">
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex-center drop-down-container"
            :class="`${arrPowerSkillCheck.length > 0 ? 'active' : ''}`"
          >
            <el-dropdown
              trigger="click"
              :hide-on-click="false"
              ref="dropdownPowerSkillMenu"
            >
              <div class="text-drop-down flex-mid">
                <span v-if="arrPowerSkillCheck.length > 0">
                  ({{ arrPowerSkillCheck.length }})&nbsp;
                </span>
                <div>Power Skill</div>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownHeader">
                  <div>
                    <el-button
                      @click="handleSelectAllPowerSkill"
                      class="dropdownHeaderTextStyle"
                      type="text"
                      >{{ $t("powerUp.Select_all") }}</el-button
                    >
                    <el-button
                      @click="checkedArrPowerSkillCheck = []"
                      class="dropdownHeaderTextStyle"
                      style="margin-left: 24px"
                      type="text"
                      >{{ $t("powerUp.Clear") }}</el-button
                    >
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div class="tooltipStyle" slot="content">
                      Filter by the power skill that a question is designed to
                      practice and develop
                    </div>
                    <div class="flex-center">
                      <img
                        :src="$utils('icons', 'ic_help_outline-16px')"
                        alt="icons_ic_help_outline-16px"
                      />
                    </div>
                  </el-tooltip>
                </div>
                <div class="dropdownItem-tabActivity thin-scrollbar">
                  <el-checkbox-group v-model="checkedArrPowerSkillCheck">
                    <el-dropdown-item
                      v-for="item in powerSkillOption"
                      :key="item.type"
                    >
                      <el-checkbox :label="item.type" :key="item.type">{{
                        item.type
                      }}</el-checkbox>
                    </el-dropdown-item>
                  </el-checkbox-group>
                </div>
                <div class="dropdownFooter">
                  <el-button @click="clearPowerSkillSelected" type="cancel">{{
                    $t("powerUp.Cancel")
                  }}</el-button>
                  <el-button @click="savePowerSkillFiltered" type="save">{{
                    $t("powerUp.Okay")
                  }}</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <div
              v-if="arrPowerSkillCheck.length > 0"
              class="relative"
              style="width: 26px"
            >
              <div
                @click="
                  (checkedArrPowerSkillCheck = []), savePowerSkillFiltered()
                "
                class="drop-down-close"
              >
                <div class="x-btn"></div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 220px">
          <el-menu class="input-select" mode="horizontal">
            <el-submenu index="0" style="width: 220px">
              <template slot="title">
                <span class="text-dropdown"
                  >{{ selectStatus }} ({{
                    countquestion[status] ? countquestion[status] : 0
                  }})</span
                >
              </template>
              <el-menu-item
                @click="statusClick('Active')"
                index="1"
                style="font-size: 14px; width: 220px"
                >{{ $t("questions.Active") }} ({{
                  countquestion.N ? countquestion.N : 0
                }})</el-menu-item
              >
              <el-menu-item
                @click="statusClick('Inactive')"
                index="2"
                style="font-size: 14px; width: 220px"
                >{{ $t("questions.Inactive") }} ({{
                  countquestion.Y ? countquestion.Y : 0
                }})</el-menu-item
              >
              <el-menu-item
                @click="statusClick('Show All')"
                index="3"
                style="font-size: 14px; width: 220px"
                >{{ $t("questions.Show_All") }} ({{
                  countquestion.all ? countquestion.all : 0
                }})</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="line-style mt-32" />
      <div>
        <el-table
          v-if="viewReady"
          :data="questions"
          :cell-style="{ padding: '8px 0' }"
          fixed
          empty-text="No questions found"
          ref="table2"
          style="width: 100%"
          @sort-change="handleSortChange">
          <el-table-column
            class="headerCenter"
            :label="$t('questions.Status')"
            prop="block"
            width="85"
            min-width="50"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-switch
                @change="handleBlock(scope.row)"
                v-model="scope.row.block_status"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('questions.Question')"
            prop="question_en"
            width="420"
            sortable
          >
            <template slot-scope="scope">
              <div style="line-height: 16px">
                <div style="line-height: 18px">
                  <span>
                    <span
                      v-for="(data, index) in getTeamNames(scope.row)"
                      :key="index + '_span_tage'"
                    >
                      <span class="question-send-to" v-if="index < 2">{{
                        data
                      }}</span>
                      <el-tooltip
                        v-else-if="index == 2"
                        effect="dark"
                        placement="left"
                      >
                        <div class="" slot="content">
                          <span
                            v-for="(
                              data, index
                            ) in getTeamNames(scope.row).slice(2)"
                            :key="index + 'tootip'"
                          >
                            <div>{{ data }}</div>
                          </span>
                        </div>
                        <span class="question-send-to"
                          >+ {{ getTeamNames(scope.row).length - 2 }}</span
                        >
                      </el-tooltip>
                    </span>
                  </span>
                  <span
                    class="fw-700 fs-14"
                    :class="getQuestionFontClass(getLocalizedQuestionText(scope.row))"
                    style="
                      color: #000000;
                      white-space: normal;
                      word-wrap: break-word;
                      line-height: 18px;
                    "
                    >{{ getLocalizedQuestionText(scope.row) }}
                    <el-tooltip v-if="hasFollowUpQuestions(scope.row)" effect="dark" placement="top">
                      <div slot="content">
                        <div v-for="(followUp, index) in getFollowUpQuestionsText(scope.row)" :key="index" style="margin-bottom: 8px;">
                          <strong>{{ followUp.options.join(', ') }}:</strong><br>
                          {{ followUp.text }}
                        </div>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="9" viewBox="0 0 21.5 9.121" style="display: inline-block; vertical-align: middle; margin-left: 8px;">
                        <g transform="translate(-1.25 -7.439)">
                          <circle cx="3" cy="3" r="3" transform="translate(2 9)" fill="none" stroke="#6C30CC" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                          <path d="M22,12H12m10,0c0,.562-.438.99-1.314,1.844L19.029,15.5M22,12c0-.562-.438-.99-1.314-1.844L19.03,8.5" fill="none" stroke="#6C30CC" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                        </g>
                      </svg>
                    </el-tooltip></span
                  >
                </div>
                <div class="question-meta-badges">
                  <span class="question-type-badge" :class="getQuestionTypeBadgeClass(scope.row.type)">
                    {{ scope.row.type_name }}
                  </span>
                  <el-tooltip v-if="scope.row.power_skill" effect="dark" placement="top">
                    <div slot="content">Power Skill: {{ scope.row.power_skill }}</div>
                    <span class="power-skill-badge">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle; margin-right: 2px;">
                        <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" fill="currentColor"/>
                      </svg>
                      {{ scope.row.power_skill }}
                    </span>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Dimension" prop="schedule_name" width="140" sortable>
            <template slot-scope="scope">
              <div style="line-height: 16px">
                <div class="fs-14 fw-600" style="color: #000000; margin-bottom: 6px;">
                  {{ scope.row.category_name }}
                </div>
                <span v-if="scope.row.frequency && !scope.row.frequency.toLowerCase().includes('follow')" 
                      class="frequency-tag" 
                      :class="getFrequencyTagClass(scope.row.frequency)">
                  {{ scope.row.frequency }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column 
            prop="next_occurrence" 
            label="Next" 
            min-width="100"
            sortable="custom">
            <template slot-scope="scope">
              {{ getNextOccurrence(scope.row) || '-' }}
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('questions.Action')"
            header-align="center"
            width="170"
            min-width="65"
            align="center"
          >
            <template slot-scope="scope">
              <div style="display: flex; gap: 6px; justify-content: center;">
                <el-button
                  class="btnActionView btn-gray-outline"
                  style="padding: 8px 14px; font-size: 14px;"
                  @click="handleEdit(scope.$index, scope.row)"
                  >{{ $t("global.edit") }}</el-button
                >
                <el-button
                  v-if="
                    (scope.row.type == 'Multiple Choice' &&
                      scope.row.m_choice !== undefined &&
                      scope.row.m_choice.en !== undefined &&
                      Array.isArray(scope.row.m_choice.en) &&
                      scope.row.m_choice.en.length === 2) ||
                    scope.row.type == 'Text Area Field' ||
                    scope.row.type == 'Multiple Choice(other)' ||
                    scope.row.custom_type == 'multiple_choice' ||
                    scope.row.type == 'Scale'
                  "
                  class="btnActionView btn-gray-outline"
                  style="padding: 8px 14px; font-size: 14px;"
                  @click="openModal(scope.row)"
                  >{{ $t("questions.View") }}</el-button
                >
              </div>
            </template>
          </el-table-column>
          
        </el-table>
        <div
          v-else
          class="center mb-40 pb-40 relative"
          style="margin-top: -60px; z-index: 99"
        >
          <div
            v-for="value in [1, 2, 3]"
            :key="'custom_mock_question_' + value"
            :class="{
              'opa-02': value == 3,
              'opa-04': value == 2,
              'opa-06': value == 1,
            }"
            class="flex-center"
            style="height: 58px"
          >
            <div class="flex-mid opa-06" style="width: 100px">
              <el-switch
                active-color="#ccc"
                inactive-color="#ccc"
                v-model="mockSwitch"
              ></el-switch>
            </div>
            <div class="mr-auto">
              <div class="text-skeleton fs-18" style="width: 260px">&nbsp;</div>
              <div class="text-skeleton fs-16 opa-06 mt-8" style="width: 100px">
                &nbsp;
              </div>
            </div>
            <div class="flex-center" style="width: 130px">
              <div class="text-skeleton fs-16 ml-12" style="width: 80px">
                &nbsp;
              </div>
            </div>
            <div class="flex-mid opa-02" style="width: 220px">
              <el-button class="btnActionView btn-gray-outline">
                <div class="fs-15" style="width: 24px">&nbsp;</div>
              </el-button>
              <el-button class="btnActionView btn-gray-outline">
                <div class="fs-15" style="width: 24px">&nbsp;</div>
              </el-button>
            </div>
          </div>
        </div>
      </div>





      <div id="questions_form_modal">
        <el-dialog
          width="1050px"
          top="5vh"
          :visible.sync="dialogFormEdit"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          @close="cancelDialogEdit"
        >
          <div class="grid-2-section">
            <div class="grid-left">
              <div class="header flex-center">
                <img
                  :src="$utils('icons', 'ic_preview')"
                  style="height: 24px; margin-top: -2px"
                  class="mr-12"
                />
                <span>{{ $t("questions.Preview_of_Daily_Insights") }}</span>
              </div>
              <div class="body center fc-FFFFFF">
                <div class="flex-mid">
                  <div
                    v-if="!dynamicValidateForm.category"
                    class="bg-FFFFFF opa-02 image-type"
                  ></div>
                  <div v-else>
                    <img
                      :src="retrunTypName(dynamicValidateForm.category)"
                      style="height: 52px"
                    />
                  </div>
                  <div
                    v-if="!dynamicValidateForm.category"
                    class="bg-FFFFFF bd-r-7 opa-02 ml-18"
                    style="height: 39px; width: 120px"
                  ></div>
                </div>
                <div class="flex-mid mt-12">
                  <div
                    v-if="!dynamicValidateForm.category"
                    class="bg-FFFFFF bd-r-7 opa-02"
                    style="height: 19px; width: 270px"
                  ></div>
                  <div v-else fs-14 class="fc-EAEAEA opa-058">
                    {{ $t("questions.Summary_of_insights_from") }}
                  </div>
                </div>
                <div class="flex-mid">
                  <div
                    v-if="dynamicValidateForm.type === 'Text Area Field'"
                    style="margin-top: 88px"
                  >
                    <div
                      v-if="
                        !dynamicValidateForm.question_en ||
                        !dynamicValidateForm.showResultsInDaily
                      "
                    >
                      <div
                        class="bg-FFFFFF mx-auto mt-4 bd-r-7 opa-02"
                        style="height: 23px; width: 345px"
                      ></div>
                      <div
                        class="bg-FFFFFF mx-auto mt-4 bd-r-7 opa-02"
                        style="height: 23px; width: 303px"
                      ></div>
                    </div>
                    <div v-else class="fs-20 fw-700 px-24 word-break">
                      {{ dynamicValidateForm.question_en }}
                    </div>
                    <div
                      class="mt-20"
                      v-for="index in ['1id', '2id', '3id']"
                      :key="index"
                    >
                      <div
                        class="bg-FFFFFF mx-auto bd-r-7 opa-02"
                        style="height: 16px; width: 269px"
                      ></div>
                      <div
                        class="bg-FFFFFF mx-auto mt-4 bd-r-7 opa-02"
                        style="height: 16px; width: 201px"
                      ></div>
                    </div>
                  </div>
                  <div v-else class="question-card">
                    <div
                      class="card-header pt-14 pb-10 px-16 fw-700 fs-15 word-break left"
                    >
                      <div
                        v-if="
                          dynamicValidateForm.question_en ||
                          !dynamicValidateForm.showResultsInDaily
                        "
                      >
                        {{ dynamicValidateForm.question_en }}
                      </div>
                      <div v-else>
                        <div
                          class="bg-000000 bd-r-7 opa-02"
                          style="height: 19px; width: 167px"
                        ></div>
                        <div
                          class="bg-000000 bd-r-7 opa-02 mt-4"
                          style="height: 19px; width: 130px"
                        ></div>
                      </div>
                    </div>
                    <div
                      class="card-body fc-000000 pt-18 pb-10 px-20 word-break"
                    >
                      <div
                        v-if="
                          (dynamicValidateForm.type ===
                            'Multiple Choice(other)' &&
                            dynamicValidateForm.question_en) ||
                          !dynamicValidateForm.showResultsInDaily
                        "
                      >
                        <div class="fs-24 fw-900">80%</div>
                        <div class="fs-13">
                          {{ $t("questions.responded") }}
                          {{ previewOptionsText(dynamicValidateForm.options) }}
                        </div>
                        <div class="fs-13 fc-B7B7B7 mt-6">
                          {{ $t("questions.of_ten_direct_reports") }}
                        </div>
                      </div>
                      <div
                        v-else-if="
                          (dynamicValidateForm.type === 'Multiple Choice' &&
                            dynamicValidateForm.question_en) ||
                          !dynamicValidateForm.showResultsInDaily
                        "
                      >
                        <div class="fs-24 fw-900">80%</div>
                        <div class="fs-13">
                          {{ $t("questions.responded_Yes") }}
                        </div>
                        <div class="fs-13 fc-B7B7B7 mt-6">
                          {{ $t("questions.of_ten_direct_reports") }}
                        </div>
                      </div>
                      <div
                        class="fc-3B3B3B"
                        v-else-if="
                          (dynamicValidateForm.type === 'Scale' &&
                            dynamicValidateForm.question_en) ||
                          !dynamicValidateForm.showResultsInDaily
                        "
                      >
                        <div class="fs-24 fw-900">8.3</div>
                        <div class="fs-13">
                          {{ $t("questions.average_rating_out_of") }}
                        </div>
                        <div class="fs-13 fc-B7B7B7 mt-6">
                          {{ $t("questions.of_ten_direct_reports") }}
                        </div>
                      </div>
                      <div v-else>
                        <div
                          class="bg-000000 bd-r-7 opa-02 mx-auto"
                          style="height: 28px; width: 68px"
                        ></div>
                        <div
                          class="bg-000000 bd-r-3 opa-02 mx-auto mt-5"
                          style="height: 14px; width: 135px"
                        ></div>
                        <div
                          class="bg-000000 bd-r-3 opa-01 mx-auto mt-8"
                          style="height: 14px; width: 107px"
                        ></div>
                      </div>
                      <div
                        class="flex-mid mt-30"
                        v-if="
                          (dynamicValidateForm.type &&
                            dynamicValidateForm.question_en) ||
                          !dynamicValidateForm.showResultsInDaily
                        "
                      >
                        <div
                          class="bg-27BC6C mr-4"
                          style="height: 12px; width: 12px; border-radius: 12px"
                        ></div>
                        <div class="fs-12 mt-2 fc-3B3B3B">
                          <span class="fw-900">9.2</span>
                          {{ $t("questions.of_fifty_overal") }}
                        </div>
                      </div>
                      <div v-else class="flex-mid mt-30">
                        <div
                          class="bg-000000 opa-02 ml-auto mr-4"
                          style="height: 12px; width: 12px; border-radius: 12px"
                        ></div>
                        <div
                          class="bg-000000 bd-r-3 opa-02 mr-auto"
                          style="height: 14px; width: 107px"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid-right fc-000000">
              <div class="fs-20 fw-700">{{ title_dialog }}</div>
              <el-form
                :model="dynamicValidateForm"
                ref="dynamicValidateForm"
                style="margin-left: 30%; margin-right: 32px"
              >

              <el-menu
                  style
                  :default-active="activeIndex"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
              >
              <el-menu-item
                v-for="(item, index) in language"
                :key="index"
                :index="item.code" 
                style="padding-left: 0" >
                {{
                  item.text
                }}
              </el-menu-item>
              </el-menu>


                <!-- <el-menu
                  style
                  :default-active="activeIndex"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
                >
                  <el-menu-item style="padding-left: 0" index="1">{{
                    $t("questions.english")
                  }}</el-menu-item>
                  <el-menu-item index="2" v-if="!engonly">{{
                    $t("questions.thai")
                  }}</el-menu-item>
                </el-menu> -->
                <br />
                <div style="margin-left: -130px">
                  <el-form-item :label-width="formLabelWidthF">
                    <div class="ml-auto recipients-count">
                      <span
                        class="top-header cursor-pointer"
                        @click="openRecipientsDialog"
                        >{{
                          dynamicValidateForm.recipients
                            ? dynamicValidateForm.recipients.length
                            : allUsers.length
                        }}
                        recipients</span
                      >
                    </div>
                  </el-form-item>
                </div>
                <div style="margin-left: -130px">
                  <el-form-item
                    label="Sent to"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-cascader
                      style="width: 100%"
                      class="defaulttags"
                      :placeholder="$t('powerUp.Name_of_Recipient_s')"
                      v-model="dynamicValidateForm.cascaderTo"
                      :options="optionTo"
                      :props="{ multiple: true }"
                      :disabled="!refreshInput"
                      @change="changeDataToCascader"
                      :collapse-tags="
                        dynamicValidateForm.cascaderTo
                          ? dynamicValidateForm.cascaderTo.length > 8
                          : dynamicValidateForm.cascaderTo
                      "
                      :debounce="500"
                      :filter-method="filterToFunction"
                      filterable
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <template slot-scope="{ node, data }">
                        <span>{{ data.label }}</span>
                      </template>
                    </el-cascader>
                  </el-form-item>
                </div>




                <div  style="margin-left: -130px">
                  <el-form-item
                    :label="$t('global.type')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <div class="flex">
                      <div class="mr-6">
                        <el-select
                          v-model="dynamicValidateForm.category"
                          style="width: 100%"
                          placeholder="Select Dimension"
                        >
                          <el-option
                            v-for="item in optionsCategory"
                            :key="item.key"
                            :label="item.category"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="ml-6">
                        <el-select
                          v-model="dynamicValidateForm.type"
                          style="width: 100%"
                          :placeholder="$t('questions.Question_Format')"
                          @change="onChangeQuestionsType(dynamicValidateForm.type)"
                        >
                          <el-option
                            :label="$t('questions.open_ended')"
                            value="Text Area Field"
                          ></el-option>
                          <el-option
                            :label="$t('questions.yes_or_no')"
                            value="Multiple Choice"
                          ></el-option>
                          <el-option
                            :label="$t('questions.multiple_choice')"
                            value="Multiple Choice(other)"
                          ></el-option>
                          <el-option label="Scale" value="Scale"></el-option>
                        </el-select>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item
                    :label="$t('questions.question')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-input
                      v-model="dynamicValidateForm.questions[activeIndex]"
                      auto-complete="off"
                      :placeholder="
                        questionPlaceholder(dynamicValidateForm.type, '')
                      "
                    ></el-input>
                  </el-form-item>
                  <div v-if="dynamicValidateForm.type == 'Multiple Choice'">


                    <el-form-item
                    v-for="(options, index) in getActiveOptions()"
                    :key="options.key"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                    :label="options.placeholder + ' ' + $t('questions.option')"
                    class="title-input-form"
                    :prop="activeIndex === 'en' || activeIndex === 'th' 
                      ? `options_${activeIndex}.` + index + '.value' 
                      : `options_YN.${activeIndex}.` + index + '.value'"
                  >
                 
                    <div class="flex">
                      <div class="mr-6">
                        
                        <el-input
                          v-model="options.value"
                          auto-complete="off"
                          @input="updateOptionValue(index, $event)"
                          :readonly="isReadonly()"
                          :key="isReadonly() ? 'readonly-input' : 'editable-input'"
                        ></el-input>
                      </div>
                      <div class="ml-6">
                        <div v-if="index == 0">
                          <el-select
                            v-model="dynamicValidateForm.feelingY"
                            style="width:95%"
                            @change="onChangeY(dynamicValidateForm.feelingY)"
                          >
                            <el-option
                              :label="$t('questions.positive')"
                              value="Positive"
                            ></el-option>
                            <el-option
                              :label="$t('questions.neutral')"
                              value="Neutral"
                            ></el-option>
                            <el-option
                              :label="$t('questions.negative')"
                              value="Negative"
                            ></el-option>
                          </el-select>
                        </div>
                        <div v-else>
                          <el-select
                            v-model="dynamicValidateForm.feelingN"
                            style="width:95%"
                            @change="onChangeN(dynamicValidateForm.feelingN)"
                          >
                            <el-option
                              :label="$t('questions.positive')"
                              value="Positive"
                            ></el-option>
                            <el-option
                              :label="$t('questions.neutral')"
                              value="Neutral"
                            ></el-option>
                            <el-option
                              :label="$t('questions.negative')"
                              value="Negative"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                      <div>
                        <el-button
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index, options)"
                        >
                          O->
                        </el-button>
                      </div>
                    </div>
                  </el-form-item>
                    <!-- <el-form-item
                      v-if="activeIndex=='en'||activeIndex=='th'"
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      v-for="(options, index) in dynamicValidateForm[`options_${activeIndex}`]"
                      :label="
                        options.placeholder + ' ' + $t('questions.option')
                      "
                      class="title-input-form"
                      :key="options.key"
                      :prop="`options_${activeIndex}.` + index + '.value'"
                    >
                      <div class="flex">
                        <div class="mr-6">
                          <el-input
                            v-model="options.value"
                            auto-complete="off"
                            readonly
                             :key="'readonly-input'"
                          ></el-input>
                         
                        </div>
                        <div class="ml-6">
                          <div v-if="index == 0">
                            <el-select
                              v-model="dynamicValidateForm.feelingY"
                              style="width:95%"
                              @change="onChangeY(dynamicValidateForm.feelingY)"
                            >
                              <el-option
                                :label="$t('questions.positive')"
                                value="Positive"
                              ></el-option>
                              <el-option
                                :label="$t('questions.neutral')"
                                value="Neutral"
                              ></el-option>
                              <el-option
                                :label="$t('questions.negative')"
                                value="Negative"
                              ></el-option>
                            </el-select>
                          </div>
                          <div v-else>
                            <el-select
                              v-model="dynamicValidateForm.feelingN"
                              style="width:95%"
                              @change="onChangeN(dynamicValidateForm.feelingN)"
                            >
                              <el-option
                                :label="$t('questions.positive')"
                                value="Positive"
                              ></el-option>
                              <el-option
                                :label="$t('questions.neutral')"
                                value="Neutral"
                              ></el-option>
                              <el-option
                                :label="$t('questions.negative')"
                                value="Negative"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                        <div>
                          <el-button 
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index,options)">
                            O->
                          </el-button>
                        </div>
                      </div>
                    </el-form-item> -->
                  

                  </div>
                  <div
                    v-if="dynamicValidateForm.type == 'Multiple Choice(other)'"
                  >
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      v-for="(options, index) in dynamicValidateForm.options"
                      :label="$t('questions.option') + ' ' + increase(index)"
                      class="title-input-form"
                      :key="options.key"
                    >
                      <div class="flex">
                        <div class="mr-6">
                          <div v-if="index < 2">
                            <el-input
                              auto-complete="off"
                              v-model="options[activeIndex]"
                              :placeholder="'Option ' + increase(index)"
                            >
                            </el-input>
                          </div>
                          <div v-else style="width: 172.2px">
                            <el-input
                              auto-complete="off"
                              v-model="options[activeIndex]"
                              :placeholder="'Option ' + increase(index)"
                            >
                              <i
                                slot="suffix"
                                class="el-icon-remove-outline"
                                @click="deleteOptions(options)"
                              ></i>
                            </el-input>
                          </div>
                        </div>
                        <div class="ml-6">
                          <el-select
                            v-model="options.feeling"
                            style="width:95%"
                            placeholder="Assign a Sentiment"
                          >
                            <el-option
                              :label="$t('questions.positive')"
                              value="Positive"
                            ></el-option>
                            <el-option
                              :label="$t('questions.neutral')"
                              value="Neutral"
                            ></el-option>
                            <el-option
                              :label="$t('questions.negative')"
                              value="Negative"
                            ></el-option>
                          </el-select>
                        </div>

                        
                        <div>
                          <el-button 
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index,options)">
                            O->
                          </el-button>
                        </div>
                      </div>

                    </el-form-item>
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                    >
                      <el-button class="btnAddOption" @click="addOptions">{{
                        $t("questions.add_option")
                      }}</el-button>
                    </el-form-item>
                  </div>
                  <div v-if="dynamicValidateForm.type == 'Scale'">
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      :label="$t('questions.min_label')"
                      class="title-input-form"
                    >
                      <el-col :span="13">
                        <el-input
                          auto-complete="off"
                          v-model="dynamicValidateForm.less_txts[activeIndex]"
                          placeholder="Not at all"
                        >
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="10">
                        <el-input
                          auto-complete="off"
                          :disabled="true"
                          v-model="dynamicValidateForm.min"
                        >
                        </el-input>
                      </el-col>
                    </el-form-item>
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      :label="$t('questions.max_label')"
                      class="title-input-form"
                    >
                      <el-col :span="13">
                        <el-input
                          auto-complete="off"
                          placeholder="Very important"
                          v-model="dynamicValidateForm.max_txts[activeIndex]"
                        >
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="10">
                        <el-input
                          auto-complete="off"
                          :disabled="true"
                          v-model="dynamicValidateForm.max"
                        >
                        </el-input>
                      </el-col>
                    </el-form-item>
                  </div>
                  <el-form-item
                    :label="$t('questions.reward')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-input
                      v-model="dynamicValidateForm.coins"
                      type="number"
                      :min="0"
                      auto-complete="off"
                      style="width: 100%"
                      placeholder="Coins"
                    >
                      <template slot="append">Coins</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.type == 'Text Area Field'"
                    :label="$t('questions.power_skill')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.powerSkill"
                      style="width: 100%"
                      :placeholder="$t('questions.select_power_skill')"
                      clearable
                    >
                      <el-option
                        :label="$t('category.power_skill.empathy')"
                        value="ps_empathy"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.self_awareness')"
                        value="ps_self_awareness"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.leadership')"
                        value="ps_leadership"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.initiative_making')"
                        value="ps_initiative_making"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.optimism')"
                        value="ps_optimism"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.critical_thinking')"
                        value="ps_critical_thinking"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    :label="$t('questions.frequency')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.frequency"
                      style="width: 100%"
                      @change="scheduleChange"
                      :placeholder="$t('questions.how_often_do')"
                    >
                      <el-option
                        :label="$t('category.frequency.one_time')"
                        value="onetime"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.weekly')"
                        value="weekly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.monthly')"
                        value="monthly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.quarterly')"
                        value="quarterly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.biannually')"
                        value="biannually"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.yearly')"
                        value="yearly"
                      ></el-option>
                      <el-option
                        label="Follow up"
                        value="Follow-up"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency!='Follow-up'"
                    class="title-input-form"
                    :label="$t('questions.day_of_week')"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.dayofweek"
                      style="width: 100%"
                      @change="scheduleChange"
                      :placeholder="$t('questions.what_day_of')"
                    >
                      <el-option
                        :label="$t('category.day_of_week.monday')"
                        value="monday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.tuesday')"
                        value="tuesday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.wednesday')"
                        value="wednesday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.thursday')"
                        value="thursday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.friday')"
                        value="friday"
                      ></el-option>
                      <el-option
                        v-if="dataCompany && dataCompany.alldays == true"
                        :label="$t('category.day_of_week.saturday')"
                        value="saturday"
                      ></el-option>
                      <el-option
                        v-if="dataCompany && dataCompany.alldays == true"
                        :label="$t('category.day_of_week.sunday')"
                        value="sunday"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == ''"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      :no-data-text="$t('questions.please_select_frequency')"
                      style="width: 100%"
                      :placeholder="$t('questions.and_when')"
                    ></el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'onetime'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in optionsScheduleOnetime"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                      <div class="styleMoreOption" @click="moreOptionClick">
                        <span>{{ $t("questions.more") }}...</span>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'weekly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        :label="`Every ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        }`"
                        :value="dynamicValidateForm.dayofweek"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'monthly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        :label="`First ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week1"
                      ></el-option>
                      <el-option
                        :label="`Second ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week2"
                      ></el-option>
                      <el-option
                        :label="`Third ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week3"
                      ></el-option>
                      <el-option
                        :label="`Fourth ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week4"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'quarterly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_quarterly"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'biannually'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_biannually"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'yearly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_yearly"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </div>
              

                <div v-if="dynamicValidateForm.frequency!='Follow-up'">

                <!-- Response Settings Section (only show header if there will be a Report Card Analytics section) -->
                <div v-if="dynamicValidateForm.type === 'Multiple Choice' || dynamicValidateForm.type === 'Multiple Choice(other)' || !disabledRowHeader" class="fs-13 fw-700 fc-000000 opa-05 mb-16" style="margin-left: -24px; letter-spacing: 0.5px; text-transform: uppercase;">Response Settings</div>

                <div class="flex mb-16" style="margin-left: -24px">
                  <div
                    class="relative switch-contrainer"
                  >
                    <input
                      type="checkbox"
                      id="rollingCustom"
                      class="input-checkbox"
                      v-model="dynamicValidateForm.rolling"
                    />
                    <label for="rollingCustom" class="lable-checkbox">{{
                      dynamicValidateForm.rolling
                    }}</label>
                  </div>
                  <div class="fs-14 fw-700 fc-000000 opa-07 mt-5 ml-12" style="position: relative">
                    Rolling Response
                    <el-tooltip class="header-table-tooltip" placement="top">
                      <div slot="content" class="p-5">
                        <div style="max-width: 250px">
                          Persist until the next occurrence of this question, delivering it until a response is provided
                        </div>
                      </div>
                      <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer" style="position: absolute; top: 1px;"
                alt="icons_ic_help_outline-16px" />
                    </el-tooltip>
                  </div>
                </div>

                <div class="flex mb-16" style="margin-left: -24px">
                  <div
                    class="relative switch-contrainer"
                  >
                    <input
                      type="checkbox"
                      id="showResultsInDailyCustom"
                      class="input-checkbox"
                      v-model="dynamicValidateForm.showResultsInDaily"
                    />
                    <label for="showResultsInDailyCustom" class="lable-checkbox">{{
                      dynamicValidateForm.showResultsInDaily
                    }}</label>
                  </div>
                  <div class="fs-14 fw-700 fc-000000 opa-07 mt-5 ml-12">
                    {{ dynamicValidateForm.showResultsInDaily ? 'Submit Responses to Managers' : 'Private Feedback Mode' }}
                  </div>
                </div>
                <div class="mb-16" style="padding: 12px; background: rgba(0, 0, 0, 0.05); margin-left: -24px; margin-top: -16px; border-radius: 8px;" v-if="!dynamicValidateForm.showResultsInDaily">
                    Responses are hidden from managers and can only be viewed as anonymous feedback
                </div>

                <!-- Report Card Analytics Section (only show header if there are multiple sections) -->
                <div v-if="dynamicValidateForm.type === 'Multiple Choice' || dynamicValidateForm.type === 'Multiple Choice(other)' || !disabledRowHeader" class="fs-13 fw-700 fc-000000 opa-05 mb-16 mt-32" style="margin-left: -24px; letter-spacing: 0.5px; text-transform: uppercase;">Report Card Analytics</div>

                <div class="flex mb-16" style="margin-left: -24px" v-if="!disabledRowHeader">
                  <div
                    class="relative switch-contrainer"
                  >
                    <input
                      type="checkbox"
                      id="report_card_Custom"
                      class="input-checkbox"
                      v-model="dynamicValidateForm.report_card"
                      @change="generateRowHeader(dynamicValidateForm)"
                      :disabled="disabledRowHeader"
                    />
                    <label for="report_card_Custom" class="lable-checkbox">{{
                      dynamicValidateForm.report_card
                    }}</label>
                  </div>
                  <div class="fs-14 fw-700 fc-000000 opa-07 mt-5 ml-12">
                    Include in Insights → Report Card
                  </div>
                </div>

                <div style="margin-left: -130px" class="mb-16" v-if="!disabledRowHeader && dynamicValidateForm.report_card">
                  <el-form-item
                    :label="$t('questions.Row_Header')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <div class="" v-if="loadingRowHeader">
                      <loading-even></loading-even>
                    </div>
                    <el-input
                      v-else
                      auto-complete="off"
                      :placeholder="$t('questions.Row_Header_Placeholder')"
                      v-model="row_header"
                    ></el-input>

                  </el-form-item>
                </div>

                <div class="flex mb-16" style="margin-left: -24px" v-if="dynamicValidateForm.type === 'Multiple Choice' || dynamicValidateForm.type === 'Multiple Choice(other)' || dynamicValidateForm.type === 'Scale'">
                  <div
                    class="relative switch-contrainer"
                  >
                    <input
                      type="checkbox"
                      id="culture_index"
                      class="input-checkbox"
                      v-model="dynamicValidateForm.culture_index"
                    />
                    <label for="culture_index" class="lable-checkbox">{{
                      dynamicValidateForm.culture_index
                    }}</label>
                  </div>
                  <div class="fs-14 fw-700 fc-000000 opa-07 mt-5 ml-12" style="position: relative">
                    Include in Culture Index
                    <el-tooltip class="header-table-tooltip" placement="top">
                      <div slot="content" class="p-5">
                        <div style="max-width: 250px">
                          Include this question in the Culture Index calculation shown in Insights Dashboard
                        </div>
                      </div>
                      <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer" style="position: absolute; top: 1px;"
                alt="icons_ic_help_outline-16px" />
                    </el-tooltip>
                  </div>
                </div>



                </div>
              </el-form>
              <span
                slot="footer"
                class="dialog-footer"
                style="margin-left: 150px"
              >
                <el-button
                  class="btn-add bigger"
                  type="primary"
                  @click="saveQuestion"
                  :disabled="loadingRowHeader"
                  >{{ $t("global.SAVE") }}</el-button
                >
                <el-button
                  class="btn-cancel bigger"
                  @click="cancelDialogEdit"
                  >{{ $t("global.CANCEL") }}</el-button
                >
                <el-button class="btn-delete bigger" @click="deleteQuestion">{{
                  $t("global.DELETE")
                }}</el-button>
              </span>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>

    <el-dialog
      class="txtHeaderModal"
      width="960px"
      :visible.sync="dialogOpenEnded"
      top="7vh"
    >
      <div class="flex" style="align-items: flex-start;">
        <div style="flex: 1; min-width: 0; margin-right: 20px;">
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
            }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break" style="display: block; line-height: 1.4;">{{
              quest_name
            }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{
              $t("questions.Open_ended")
            }}</span>
          </div>
        </div>
        <div class="flex-center" style="padding-top: 35px; gap: 12px; flex-shrink: 0;">
          <!-- Team Filter Dropdown -->
          <div class="flex-center drop-down-container" :class="`${selectedTeamFilter !== 'all' ? 'active' : ''}`">
            <el-dropdown trigger="click" @command="handleTeamFilterChange">
              <div class="text-drop-down flex-mid">
                <span v-if="selectedTeamFilter !== 'all'">
                  {{ (selectedTeamInfo && selectedTeamInfo.label) || 'Team' }}
                  <svg v-if="selectedTeamInfo && selectedTeamInfo.hasChildren" class="aggregation-indicator" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                    <title>Includes responses from child teams</title>
                    <path d="M8 2L2 8l6 6V10h6V6h-6V2z"/>
                  </svg>
                </span>
                <span v-else>All Teams</span>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="team-dropdown-header">
                  <span class="dropdown-header-title">Filter by Team</span>
                </div>
                <div class="team-search-container">
                  <el-input
                    v-model="teamSearchQuery"
                    placeholder="Search teams..."
                    prefix-icon="el-icon-search"
                    size="mini"
                    clearable
                  ></el-input>
                </div>
                <div class="team-dropdown-content">
                  <el-dropdown-item 
                    v-for="option in availableTeamOptions" 
                    :key="option.value"
                    :command="option.value"
                    :class="{ 'selected-team': selectedTeamFilter === option.value }"
                  >
                    <div class="team-option-content">
                      <div class="team-option-main">
                        <span class="team-name">{{ option.label }}</span>
                        <span class="team-response-count">({{ option.responseCount }})</span>
                      </div>
                    </div>
                  </el-dropdown-item>
                  <div v-if="availableTeamOptions.length === 1" class="no-teams-found">
                    <span>No teams found</span>
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          
          <el-button
            type="text"
            @click="downloadExcel_Open_ended()"
            :disabled="loading"
          >
            <div class="flex-mid">
              <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="shadowBottom" />
      <div class="mt-12">
        <!-- Aggregation Info Message -->
        <div v-if="selectedTeamFilter !== 'all' && selectedTeamInfo && selectedTeamInfo.hasChildren" 
             class="aggregation-info-banner">
          <i class="el-icon-info"></i>
          <span>Showing combined responses from {{ selectedTeamInfo.label }} and its sub-teams</span>
        </div>

        <el-table
          id="openEndedTable"
          v-loading="loading"
          :data="filteredDataOpenEnd"
          :cell-style="{ padding: '6px 0px' }"
          :empty-text="loading ? ' ' : (selectedTeamFilter !== 'all' ? 'No responses available for selected team' : 'No responses available')"
          height="520"
        >
          <el-table-column :render-header="renderHeaderOpenEnded">
            <template slot-scope="scope">
              <!-- <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadingFeedbackAI">
                <loading-even></loading-even>
              </div> -->
              <div
                v-if="scope.row.Summary"
                class="summaryLayout"
              >
                <div class="pt-16">
                  <span
                    class="txtHeaderSummary"
                    >Summary
                  </span>
                </div>
                <div class="divAllSummary pb-12">
                  <span
                    class="txtAllSummary"
                    :style="$utils('fontStyle', scope.row.Summary)"
                    >{{ scope.row.Summary }}
                  </span>
                </div>
                <div style="margin-bottom: 8px; max-height: 164px; flex-wrap: wrap" class="flex divAllSummary">
                  <div class="talkingPointsBox" v-for="(item,index) in scope.row.response_talking_points_show.slice(0, 20)" :key="index">
                    <el-tooltip effect="light" placement="top" class="custom-tooltip">
                      <div class="tooltipStyleTalkingPoints" slot="content">
                        <span class="fs-13 fw-700">{{ item.point.title }}</span>
                        <div v-if="item.point && item.point.specific_examples">
                          <div class="tooltip-items" v-for="(item_specific,index_specific) in item.point.specific_examples" :key="index+'_'+index_specific">
                            <div class="tooltip-item">
                              <div class="oi-circle">
                                <span class="fs-11">{{ index_specific+1 }}</span>
                              </div>
                              <p>
                                {{ item_specific }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-tag :class="`talking-points ${item.sentiment == 'positive'
                        ? 'GreenBoxStyle'
                        : item.sentiment == 'negative'
                          ? 'RedBoxStyle'
                          : 'GreyBoxStyle'
                        }`" v-bind:style="'margin-bottom: 8px;' +
                          $utils('fontStyle', item.point.title)
                          ">{{ truncateText(item.point.title) }}</el-tag>
                    </el-tooltip>
                  </div>
                </div>
                <div class="divAllSummary pb-16">
                  <span
                    class="txtRepeats"
                    >AI-generated from feedback shared within 3 months of the selected date
                  </span>
                </div>
              </div>
              <div v-else style="
                  padding: 24px 0;
                  background: rgba(0, 0, 0, 0.03);
                  align-items: flex-start;
                  display: flex;
                  flex-direction: column;
                ">
                <div class="feedback-team-label" v-if="scope.row.team" :class="getTeamColorClass(getTeamNameInfo(scope.row.team).teamId || scope.row.team)">
                  <span :class="[ blurMode ?  'blurelement': '' ]">
                    {{ getTeamNameInfo(scope.row.team).name }}
                  </span>
                </div>
                <span class="txtResponse" :style="$utils('fontStyle', scope.row.answer || scope.row)">{{ scope.row.answer || scope.row }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="center mt-20 mb-40 pt-20 pb-40"
          v-if="!loadingDataOpenedTable"
        >
          <loading-even></loading-even>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="txtHeaderModal"
      width="960px"
      :visible.sync="dialogYesNo"
      top="7vh"
    >
      <div class="flex" style="align-items: flex-start;">
        <div style="flex: 1; min-width: 0; margin-right: 20px;">
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
            }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break" style="display: block; line-height: 1.4;">{{
              quest_name
            }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">Yes/No</span>
          </div>
        </div>
        <div style="padding-top: 35px; flex-shrink: 0;">
          <el-button
            type="text"
            @click="downloadExcel_YesorNO()"
            :disabled="loading"
          >
            <div class="flex-mid">
              <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>

      <div class="shadowBottom" />
      <div class="mt-12">
        <el-table
          id="yesNoTable"
          v-loading="loading"
          :data="datalist"
          :cell-style="{ padding: '0' }"
          :empty-text="loading ? ' ' : 'No responses available'"
          ref="teamsTable"
          style="width: 100%"
          height="520"
        >
          <el-table-column width="1" height="50"></el-table-column>
          <el-table-tree-column
            file-icon="icon icon-folder"
            folder-icon="icon icon-folder"
            :allRemote="true"
            expandKey="extended"
            child-key="children"
            width="52"
            height="50"
          ></el-table-tree-column>
          <el-table-column :render-header="renderHeaderYesNo">
            <template slot-scope="scope">
              <div style="flex-direction: row; display: flex; margin: 5px 0;">
                <div class="rowItem flex-center">
                  <div class="flex-column">
                    <span class="txtTeam"
                    :class="[ blurMode ?  'blurelement': '' ]"
                     :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ scope.row.team }}
                    </span>
                    <span v-if="scope.row.id && datamultichoices[scope.row.id]" 
                          class="fs-12 fw-400 fc-626262 opa-06 lh-14"
                          :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ getTotalResponses(scope.row.id) }} responses
                    </span>
                  </div>
                </div>
                <div v-if="scope.row.id" style="margin-left: 20px">
                  <div
                    class="flex"
                    style="width: 577px; border-radius: 4px; overflow: hidden"
                  >
                    <div
                      v-if="scope.row.id"
                      :class="
                        !yes ? 'bar-results color-4' : 'bar-results color-2'
                      "
                      :style="`${getColorPercent(getNoPercent(scope.row.id))}`"
                    >
                      <span v-if="getNoPercent(scope.row.id) > 5"
                        >{{ getNoPercent(scope.row.id) }}%</span
                      >
                    </div>
                    <div
                      :class="
                        yes ? 'bar-results color-4' : 'bar-results color-2'
                      "
                      v-if="scope.row.id"
                      :style="`${getColorPercent(getYesPercent(scope.row.id))}`"
                    >
                      <span v-if="getYesPercent(scope.row.id) > 5"
                        >{{ getYesPercent(scope.row.id) }}%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      class="txtHeaderModal"
      width="960px"
      :visible.sync="dialogScale"
      top="7vh"
    >
      <div class="flex" style="align-items: flex-start;">
        <div style="flex: 1; min-width: 0; margin-right: 20px;">
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
            }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break" style="display: block; line-height: 1.4;">{{
              quest_name
            }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">Scale</span>
          </div>
        </div>
        <div style="padding-top: 35px; flex-shrink: 0;">
          <el-button
            type="text"
            @click="downloadExcel_Scale()"
            :disabled="loading"
          >
            <div class="flex-mid">
              <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>

      <div class="shadowBottom" />

      <div class="mt-12">
        <el-table
          id="scaleTable"
          v-loading="loading"
          :data="datalist"
          :cell-style="{ padding: '0' }"
          :empty-text="loading ? ' ' : 'No responses available'"
          ref="yesNoTable"
          style="width: 100%"
          height="520"
        >
          <el-table-column width="1" height="50"></el-table-column>
          <el-table-tree-column
            file-icon="icon icon-folder"
            folder-icon="icon icon-folder"
            :allRemote="true"
            expandKey="extended"
            child-key="children"
            width="52"
            height="50"
          ></el-table-tree-column>

          <el-table-column :render-header="renderHeaderScale">
            <template slot-scope="scope">
              <div style="flex-direction: row; display: flex; margin: 5px 0">
                <div class="rowItem flex-center">
                  <div class="flex-column">
                    <span class="txtTeam" :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ scope.row.team }}
                    </span>
                    <span v-if="scope.row.id && datamultichoices[scope.row.id]" 
                          class="fs-12 fw-400 fc-626262 opa-06 lh-14"
                          :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ getTotalResponses(scope.row.id) }} responses
                    </span>
                  </div>
                </div>
                <div
                  style="width: 40px"
                  class="ml-16 fs-14 fw-700 fc-000000 opa-07 flex-mid"
                >
                  <div
                    v-if="scope.row.id && datamultichoices[scope.row.id]"
                    class="ml-auto"
                  >
                    {{ datamultichoices[scope.row.id].avg }}
                  </div>
                </div>
                <div
                  v-if="scope.row.id && datamultichoices[scope.row.id]"
                  style="margin-left: 12px"
                >
                  <div
                    class="flex"
                    :style="`width: 537px; border-radius: 4px; overflow: hidden`"
                  >
                    <div
                      v-for="(item, index) in datamultichoices[scope.row.id]
                        .range"
                      :key="index"
                      :class="`bar-results color-` + getScaleColor(index)"
                      :style="`${getColorPercentForScale(
                        getScalePercent(scope.row.id, index)
                      )}`"
                    >
                      <span v-if="getScalePercent(scope.row.id, index) > 5"
                        >{{ getScalePercent(scope.row.id, index) }}%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      class="txtHeaderModal"
      width="960px"
      :visible.sync="dialogMultipleOther"
      top="7vh"
    >
      <div class="flex" style="align-items: flex-start;">
        <div style="flex: 1; min-width: 0; margin-right: 20px;">
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
            }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break" style="display: block; line-height: 1.4;">{{
              quest_name
            }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{
              $t("questions.Multiple_Choice")
            }}</span>
          </div>
        </div>
        <div style="padding-top: 35px; flex-shrink: 0;">
          <el-button
            type="text"
            @click="downloadExcel_MultipleChoice()"
            :disabled="loading"
          >
            <div class="flex-mid">
              <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>

      <div class="shadowBottom" />

      <div class="mt-12">
        <el-table
          id="otherTable"
          v-loading="loading"
          :data="datalist"
          :cell-style="{ padding: '0' }"
          :empty-text="loading ? ' ' : 'No responses available'"
          ref="otherTable"
          style="width: 100%"
          height="520"
        >
          <el-table-column width="1" height="50"></el-table-column>
          <el-table-tree-column
            file-icon="icon icon-folder"
            folder-icon="icon icon-folder"
            :allRemote="true"
            expandKey="extended"
            child-key="children"
            width="52"
            height="50"
          ></el-table-tree-column>

          <el-table-column :render-header="renderHeaderMultipleOther">
            <template slot-scope="scope">
              <div style="flex-direction: row; display: flex; margin: 5px 0">
                <div class="rowItem flex-center">
                  <div class="flex-column">
                    <span class="txtTeam" 
                    :class="[ blurMode ?  'blurelement': '' ]"
                    :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ scope.row.team }}
                    </span>
                    <span v-if="scope.row.id && datamultichoices[scope.row.id]" 
                          class="fs-12 fw-400 fc-626262 opa-06 lh-14"
                          :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ getTotalResponses(scope.row.id) }} responses
                    </span>
                  </div>
                </div>

                <div v-if="scope.row.id" class="ml-20">
                  <div
                    class="flex"
                    style="width: 577px; border-radius: 4px; overflow: hidden"
                  >
                    <div
                      v-for="(item, index) in datamultichoices[scope.row.id]"
                      :key="index"
                      :style="`width: ${getMultipleChoicePercent(
                        scope.row.id,
                        index
                      )}%`"
                    >
                      <div
                        v-if="getMultipleChoicePercent(scope.row.id, index) > 6"
                        :class="
                          `bar-results color-` + getMultipleChoiceColor(index)
                        "
                        :style="`width: 100%;`"
                      >
                        <span
                          >{{
                            getMultipleChoicePercent(scope.row.id, index)
                          }}%</span
                        >
                      </div>
                      <el-tooltip
                        v-else-if="
                          getMultipleChoicePercent(scope.row.id, index)
                        "
                        :content="`${getMultipleChoicePercent(
                          scope.row.id,
                          index
                        )}%`"
                        placement="top"
                      >
                        <div
                          :class="
                            `bar-results color-` + getMultipleChoiceColor(index)
                          "
                          :style="`width: 100%;`"
                        >
                          &nbsp;
                        </div>
                      </el-tooltip>
                    </div>
                    <!-- <div
                      v-for="(item, index) in datamultichoices[scope.row.id]"
                      :key="index"
                      :class="
                        `bar-results color-` + getMultipleChoiceColor(index)
                      "
                      :style="`${getColorPercent(
                        getMultipleChoicePercent(scope.row.id, index)
                      )}`"
                    >
                      <span
                        v-if="getMultipleChoicePercent(scope.row.id, index) > 5"
                        >{{
                          getMultipleChoicePercent(scope.row.id, index)
                        }}%</span
                      >
                    </div> -->
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <div class="remove-padding-modal">
      <el-dialog
        :visible.sync="recipientsModal"
        top="12vh"
        width="360px"
        @close="cancelAdd"
      >
        <div class="RecipientsModalStyle px-40">
          <div>
            <span class="fs-20 fw-700 fc-000000">{{
              "Question Recipients"
            }}</span>
          </div>
          <div class="mt-24">
            <span class="fs-18 fw-700 fc-000000"
              >{{
                $utils(
                  "addCommasInNumber",
                  dynamicValidateForm.recipients
                    ? dynamicValidateForm.recipients.length
                    : allUsers.length
                )
              }}
              {{ $t("powerUp.recipients") }}</span
            >
          </div>
          <div class="mt-4 pb-16">
            <span class="fc-6C30CC fs-14">{{
              $t("powerUp.based_on_your_selection")
            }}</span>
          </div>
        </div>
        <div class="divMembersRecipients thin-scrollbar px-40">
          <div
            v-for="item in dynamicValidateForm.recipients"
            :key="item.key"
            class="rowDataStyle"
          >
            <div>
              <div class="divProfile">
                <div v-if="item.profilepic">
                  <img
                    v-lazy="item.profilepic"
                    :key="item.profilepic"
                    class="imgProfile flex-mid"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div v-else class="imgProfile"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div
                    class="flex-mid text-in-image"
                    style="width: 42px"
                    :class="[
                      `${item === 0 ? 'text-in-image-44' : 'text-in-image-32'}`,
                    ]"
                  >
                    {{
                      $utils("acronymName", {
                        firstName: item.firstname,
                        lastName: item.lastname,
                      })
                    }}
                  </div>
                </div>

                <div class="flex-column pl-16">
                  <span class="text-name"
                  :class="[ blurMode ?  'blurelement': '' ]"
                    >{{ item.firstname }} {{ item.lastname }}</span
                  >
                  <span class="text-email"
                  :class="[ blurMode ?  'blurelement': '' ]">{{ item.email }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>


        <!-- follow up question -->
    <el-dialog
    class="txtHeaderModal"
      width="720px"
      :visible.sync="follow_up_question"
      
    >
    <div class="flex-column">
      <div class="fs-20 fw-900">Add Follow-up Question</div>
      <div class="fs-18 fw-900 mt-24 mb-29" style="margin-bottom:29px">{{titleName}}</div>
      <div>

        <el-select
          v-model="selectquestionFollewUp"
          filterable
          placeholder="Select"
          class="input-style"
          style="width:500px;"
        >
          <el-option
            class="text-dropdown"
            v-for="item in questionFollewUp"
            :key="item.key"
            :label="item.question_en"
            :value="item.key"
          ></el-option>
        </el-select>
       
      </div>
      <div class="mt-32" style="margin-bottom:40px">
        <el-button
          type="primary"
          @click="addFollowUpQuestion"
          class="btn-add bigger">
          SUBMIT</el-button>
        <el-button
          @click="addFollowUpQuestion"
          class="btn-cancel bigger">
          CANCEL</el-button>
      </div>
    </div>
    </el-dialog>


  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "custom",
  props: {
    viewReady: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    loadingEven: require("../even/loading").default,
  },
  created() {
    this.$store.commit("authen/setActiveIndex", "4");
  },
  mounted() {
    // Initial sort - only if data is available
    if (this.viewReady && this.questions && this.questions.length > 0) {
      this.hasSortedInitialQuestions = true;
      this.handleSortChange({
        prop: 'next_occurrence',
        order: 'ascending'
      });
    }

    this.$root.$on('languageChanged', this.handleLanguageChange);
  },
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('languageChanged', this.handleLanguageChange);
  },
  computed: {
    engonly() {
      return this.$store.getters["reward/engonly"];
    },
    inputSearch: {
      get() {
        return this.$store.getters["custom/inputSearch"];
      },
      set(value) {
        this.$store.commit("custom/setinputSearch", { value });
      },
    },
    datalist() {
      return this.$store.getters["question/datalist"];
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    questions() {
      return this.$store.getters["custom/questions"];
    },
    countquestion() {
      return this.$store.getters["custom/countquestion"];
    },
    optionsCategory() {
      return this.$store.getters["question/category"];
    },
    optionsScheduleOnetime() {
      return this.$store.getters["question/scheduleonetime"];
    },
    dateoptions() {
      return this.$store.getters["question/dateoptions"];
    },
    dataopenend() {
      this.loadingDataOpenedTable = ++this.loadingDataOpenedTable;
      return this.$store.getters["question/dataopenend"];
    },
    datamultichoices() {
      return this.$store.getters["question/datamultichoices"];
    },
    countmultichoices() {
      return this.$store.getters["question/countmultichoices"];
    },
    loading() {
      return this.$store.getters["question/loading"];
    },
    dateShow() {
      return this.$store.getters["question/dateShow"];
    },
    teamArr() {
      return this.$store.getters["question/teamArr"];
    },
    teamAll() {
      return this.$store.getters["question/teamAll"];
    },
    organizations() {
      return this.$store.getters["question/organizations"];
    },
    answerOpt() {
      return this.$store.getters["question/answerOpt"];
    },
    localizedAnswerOptions() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      if (!this.currentQuestionData || !this.currentQuestionData.m_choice) {
        return this.answerOpt; // Fallback to store data
      }
      
      // Check for selected language first
      if (this.currentQuestionData.m_choice[selectedLanguage]) {
        // For Yes/No questions, check if we need to reverse the order
        // if (this.currentQuestionData.m_choice.weight && (this.currentQuestionData.m_choice.weight[0] === "0" || this.currentQuestionData.m_choice.weight[0] === 0)) {
        //   return [...this.currentQuestionData.m_choice[selectedLanguage]].reverse();
        // }
        return this.currentQuestionData.m_choice[selectedLanguage];
      }
      
      // Fallback to English
      if (this.currentQuestionData.m_choice.en) {
        // if (this.currentQuestionData.m_choice.weight && (this.currentQuestionData.m_choice.weight[0] === "0" || this.currentQuestionData.m_choice.weight[0] === 0)) {
        //   return [...this.currentQuestionData.m_choice.en].reverse();
        // }
        return this.currentQuestionData.m_choice.en;
      }
      
      return this.answerOpt; // Final fallback
    },
    localizedAnswerOptionsOther() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      if (!this.currentQuestionData || !this.currentQuestionData.m_choice) {
        return this.answerOpt; // Fallback to store data
      }
      
      // Check for selected language first
      if (this.currentQuestionData.m_choice[selectedLanguage]) {
        // For Yes/No questions, check if we need to reverse the order
        // This must not be a special question. // weihth 0,1,1,0
        if (this.currentQuestionData.key !== '-L1FmpFO-v8IZc_B5EB7' && this.currentQuestionData.m_choice.weight && (this.currentQuestionData.m_choice.weight[0] === "0" || this.currentQuestionData.m_choice.weight[0] === 0)) {
          return [...this.currentQuestionData.m_choice[selectedLanguage]].reverse();
        }
        return this.currentQuestionData.m_choice[selectedLanguage];
      }
      
      // Fallback to English
      if (this.currentQuestionData.m_choice.en) {
        // This must not be a special question. // weihth 0,1,1,0
        if (this.currentQuestionData.key !== '-L1FmpFO-v8IZc_B5EB7' && this.currentQuestionData.m_choice.weight && (this.currentQuestionData.m_choice.weight[0] === "0" || this.currentQuestionData.m_choice.weight[0] === 0)) {
          return [...this.currentQuestionData.m_choice.en].reverse();
        }
        return this.currentQuestionData.m_choice.en;
      }
      
      return this.answerOpt; // Final fallback
    },
    optionTo() {
      return this.$store.getters["question/optionTo"];
    },
    allUsers() {
      return this.$store.getters["question/allUsers"];
    },
    cohortsUser() {
      return this.$store.getters["question/cohortsUser"];
    },
    _organization1level() {
      return this.$store.getters["question/organization1level"];
    },
    userTeam() {
      return this.$store.getters["question/userTeam"];
    },
    dimensionOption(){
      return this.$store.getters["question/dimensionOption"];
    },
    deletedTeam(){
      return this.$store.getters["question/deletedTeam"];
    },
    teamHeight(){
      return this.$store.getters["question/teamHeight"];
    },
    loadingFeedbackAI() {
      return this.$store.getters["question/loadingFeedbackAI"];
    },
    summaryDetail(){
      return this.$store.getters["question/summaryDetail"];
    },
    dataCompany(){
      return this.$store.getters["question/dataCompany"];
    },
    row_header: {
      get() {
        return this.$store.getters["question/row_header"];
      },
      set(value) {
        this.$store.commit("question/setRowHeader", value);
      },
    },
    loadingRowHeader() {
      return this.$store.getters["question/loadingRowHeader"];
    },
    questioncustomAll(){
      return this.$store.getters["custom/questioncustomAll"];
    },
    language() {
      return this.$store.getters["reward/language"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    filteredDataOpenEnd() {
      if (this.selectedTeamFilter === 'all') {
        return this.dataopenend;
      }
      
      // Handle special 'organization' filter
      if (this.selectedTeamFilter === 'organization') {
        // Show all responses that don't have viable parent teams
        const teamIds = [...new Set(this.dataopenend
          .filter(item => !item.Summary && item.team)
          .map(item => item.team))];
        
        const organizationTeams = teamIds.filter(teamId => {
          const viableParent = this.findViableParentTeam(teamId);
          return viableParent && viableParent.teamId === 'organization';
        });
        
        return this.dataopenend.filter(item => {
          if (item.Summary) return true; // Always show summary
          return organizationTeams.includes(item.team);
        });
      }
      
      // Get selected team option to find child teams
      const selectedOption = this.availableTeamOptions.find(option => option.value === this.selectedTeamFilter);
      if (!selectedOption) return this.dataopenend;
      
      // Include the selected team and all its child teams (including those that don't meet threshold)
      const includeTeamIds = [this.selectedTeamFilter];
      if (selectedOption.childTeams) {
        includeTeamIds.push(...selectedOption.childTeams);
      }
      // Also include all descendants of the selected team
      includeTeamIds.push(...this.getAllDescendantTeams(this.selectedTeamFilter));
      
      return this.dataopenend.filter(item => {
        if (item.Summary) return true; // Always show summary
        return includeTeamIds.includes(item.team);
      });
    },
    availableTeamOptions() {
      const options = [{ value: 'all', label: 'All Teams', responseCount: this.dataopenend.filter(item => !item.Summary).length }];
      
      // Get unique teams from current dataset
      const teamIds = [...new Set(this.dataopenend
        .filter(item => !item.Summary && item.team)
        .map(item => item.team))];
      
      // Group teams by their viable parent (the closest ancestor that meets threshold)
      const viableTeams = new Map();
      
      teamIds.forEach(teamId => {
        const viableParent = this.findViableParentTeam(teamId);
        if (viableParent) {
          if (!viableTeams.has(viableParent.teamId)) {
            viableTeams.set(viableParent.teamId, {
              ...viableParent,
              childTeams: [],
              aggregatedResponses: 0
            });
          }
          
          const responseCount = this.getTeamResponseCount(teamId);
          viableTeams.get(viableParent.teamId).aggregatedResponses += responseCount;
          
          if (teamId !== viableParent.teamId) {
            viableTeams.get(viableParent.teamId).childTeams.push(teamId);
          }
        }
      });
      
      // Convert to options format
      viableTeams.forEach((teamData, teamId) => {
        // Only add teams that meet the threshold
        if (teamData.aggregatedResponses >= this.MIN_RESPONSES_FOR_TEAM_NAME) {
          options.push({
            value: teamId,
            label: teamData.label,
            responseCount: teamData.aggregatedResponses,
            memberCount: teamData.memberCount,
            meetsThreshold: true, // All teams in this list meet threshold
            hasChildren: teamData.childTeams.length > 0,
            depth: teamData.depth,
            childTeams: teamData.childTeams
          });
        }
      });
      
      // Filter by search query
      const filtered = options.filter(option => {
        if (option.value === 'all') return true;
        return option.label.toLowerCase().includes(this.teamSearchQuery.toLowerCase());
      });
      
      return filtered.sort((a, b) => {
        if (a.value === 'all') return -1;
        if (b.value === 'all') return 1;
        return a.label.localeCompare(b.label);
      });
    },
    selectedTeamInfo() {
      // Get info for the selected team
      return this.getSelectedTeamInfo(this.selectedTeamFilter);
    },
    
    // Multi-language support
    isThaiLanguageSelected() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      return selectedLanguage === 'th';
    },
    
    isMalayLanguageSelected() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      return selectedLanguage === 'ms';
    },
    
    isChineseLanguageSelected() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      return selectedLanguage === 'zh-HK';
    },
    
    // Dynamic font class based on language selection
    questionFontClass() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      if (selectedLanguage === 'th') return 'font-kanit';
      if (selectedLanguage === 'zh-HK') return 'font-chinese';
      return 'font-lato';
    }
  },
  watch: {
    row_header() {
      this.dynamicValidateForm.report_card_label = this.row_header
    },
    viewReady(newValue) {
      if (newValue && !this.hasSortedInitialQuestions && this.questions && this.questions.length > 0) {
        this.hasSortedInitialQuestions = true;
        this.$nextTick(() => {
          this.handleSortChange({
            prop: 'next_occurrence',
            order: 'ascending'
          });
        });
      }
    },
    questions(newQuestions) {
      if (this.viewReady && !this.hasSortedInitialQuestions && newQuestions && newQuestions.length > 0) {
        this.hasSortedInitialQuestions = true;
        this.$nextTick(() => {
          this.handleSortChange({
            prop: 'next_occurrence',
            order: 'ascending'
          });
        });
      }
    },
    inputSearch() {
      this.$store.dispatch("custom/searchQuestions", this.inputSearch);
    },
    language(){
      if(this.language.length>0){

       
        for(const i in this.language){
        // console.log('language',this.language[i].code)
        if(!this.dynamicValidateForm.questions[`${this.language[i].code}`]){
          this.dynamicValidateForm.questions[`${this.language[i].code}`] = ''
        }
        if(this.dynamicValidateForm.less_txts&&!this.dynamicValidateForm.less_txts[`${this.language[i].code}`]){
          this.dynamicValidateForm.less_txts[`${this.language[i].code}`] = ''
        }
        if(this.dynamicValidateForm.max_txt&&!this.dynamicValidateForm.max_txts[`${this.language[i].code}`]){
          this.dynamicValidateForm.max_txts[`${this.language[i].code}`] = ''
        }
        if(this.dynamicValidateForm.options_YN&&!this.dynamicValidateForm.options_YN[`${this.language[i].code}`]&&this.language[i].code!='en'&&this.language[i].code!='th'){
          const arr=[
          {
            key: 1,
            value: "",
            placeholder: "Yes",
            question_id:'',
          },
          {
            key: 2,
            value: "",
            placeholder: "No",
            question_id:'',
          },
        ]
          this.dynamicValidateForm.options_YN[this.language[i].code]=JSON.parse(JSON.stringify(arr));
          this.dynamicValidateForm[`options_${this.language[i].code}`]=JSON.parse(JSON.stringify(arr));
        }
        //Sconsole.log("Ya",this.dynamicValidateForm)
        }

      }
      
    },
    selectedTeamFilter(newVal) {
      // Handle team filter change
      this.handleTeamFilterChange(newVal);
    },
    dialogOpenEnded(newVal) {
      // Reset team filters when the open-ended dialog is shown
      if (newVal) {
        this.selectedTeamFilter = 'all';
        this.teamSearchQuery = '';
        this._teamNameCache = {};
      }
    },
    dataopenend() {
      // Clear cache when dataopenend changes
      this._teamNameCache = {};
    },
  },
  data() {
    return {
      recipientsModal: false,
      selectStatus: "Show All",
      id: "",
      status: "all",
      dialogFormEdit: false,
      title_dialog: "",
      activeIndex: "en",
      formLabelWidthF: "105px",
      optionFirst: [],
      yes: true,
      dynamicValidateForm: {
        cascaderTo: [["all_teams_and_cohorts"]],
        recipients: [],
        showResultsInDaily: true,
        category: "",
        type: "",
        questions: {},
        question_en: "",
        question_th: "",
        coins: "1",
        frequency: "",
        dayofweek: "monday",
        schedule: "",
        status: "",
        options_YN:{},
        options_en: [
          { key: 1, value: "Yes", weight: "1", placeholder: "Yes",question_id:'', },
          { key: 2, value: "No", weight: "0", placeholder: "No",question_id:'', },
        ],
        options_th: [
          { key: 1, value: "ใช่", placeholder: "Yes" ,question_id:'',},
          { key: 2, value: "ไม่ใช่", placeholder: "No",question_id:'', },
        ],
        less_txt: "",
        less_txt_en: "",
        less_txts: {},
        max_txts: {},
        max_txt: "",
        max_txt_en: "",
        rolling: false,
        report_card: false,
        report_card_label: ""
      },
      options_quarterly: [],
      options_biannually: [],
      options_yearly: [],
      status_value: true,
      dialogOpenEnded: false,
      dialogYesNo: false,
      dialogScale: false,
      dialogMultipleOther: false,
      quest_id: null,
      quest_name: null,
      loadingDataOpenedTable: -1,
      quest_multiple_choice_3: true,
      quest_choice_3_value: {
        color_1: 23,
        color_2: 20,
        color_3: 7,
        color_4: 5,
        color_5: 15,
        color_6: 30,
      },
      organization1level: [],
      questionTypeOption: [
        { type: "Multiple Choice" },
        { type: "Scale" },
        { type: "Open-ended" },
        { type: "Yes/No" },
        { type: "Follow-up" },
      ],
      checkedQuestionType: [],
      questionFilterList: [],
      // dimensionOption: [
      //   { type: "A" },
      //   { type: "B" },
      // ],
      checkedDimension: [],
      dimensionFilterList: [],
      powerSkillOption: [
        { type: "Empathy" },
        { type: "Optimism" },
        { type: "Self Awareness" },
        { type: "Initiative Making" },
        { type: "Leadership" },
        { type: "Critical Thinking" },
      ],
      checkedArrPowerSkillCheck: [],
      arrPowerSkillCheck: [],
      //  optionTo: [
      //   {
      //     label: "All teams and cohorts",
      //     value: "asdfqwrqw213",
      //   },
      //   {
      //     label: "Executive Board",
      //     value: "asd2qwr2q1w13",
      //   },
      //   {
      //     label: "Purchasing & Sourcing BU",
      //     value: "as3dfqw2rq3213",
      //   },
      //   {
      //     label: "Bulky Logistics Squad",
      //     value: "sdfqqwrdsqw213",
      //   },
      //   {
      //     label: "Happily Culture Builders",
      //     value: "a1d43q2wr2w213",
      //   },
      //   {
      //     label: "Super Outer",
      //     value: "a1d4fq2wq2w2113",
      //   },
      //   {
      //     label: "Superstar",
      //     value: "as1d3qwrqw113",
      //   },
      //   {
      //     label: "0 to 6mo",
      //     value: "as143q2w113",
      //   },
      //   {
      //     label: "10+ yrs",
      //     value: "as1d43rq2w1133",
      //   },
      //   {
      //     label: "2 to 5yrs",
      //     value: "as1d43rq2w11232",
      //   },
      //   {
      //     label: "5 to 10yrs",
      //     value: "as1d43rq2w11131",
      //   },
      // ],
      // cascaderTo: [["asdfqwrqw213"]], // add to obj : dynamicValidateForm
      //showResultsInDaily: true, // add to obj : dynamicValidateForm
      refreshInput: true,
      mockSwitch: true,
      disabledRowHeader: true,
      follow_up_question:false,
      selectquestionFollewUp:'',
      questionFollewUp:[],
      indexOption:0,
      titleName:'',
      MIN_RESPONSES_FOR_TEAM_NAME: 5, // Minimum responses required for team visibility
      MIN_MEMBERS_FOR_TEAM_NAME: 10,
      USE_MEMBER_COUNT_CHECK: false, // Set to true when member counts are available
      _teamNameCache: {},
      selectedTeamFilter: 'all',
      teamFilterOptions: [],
      teamSearchQuery: '',
      maxLength: 50, // Maximum length for truncated text
      // Store current question data for localization
      currentQuestionData: null,
      hasSortedInitialQuestions: false,
    };
  },
  methods: {
    async ensureEditorMetadataReady() {
      await Promise.all([
        this.$store.dispatch("question/getChildren"),
        this.$store.dispatch("question/getCategoryOptions"),
      ]);
      await Promise.all([
        this.$store.dispatch("question/getTeamAndCohort"),
        this.$store.dispatch("question/getUser"),
        this.$store.dispatch("question/getDataCompany"),
      ]);
      await this.$store.dispatch("reward/checkEngOnly");
      this.$store.dispatch("question/getScheduleOptions", { end_row: "" });
    },
    async ensureQuestionDetailReady() {
      await Promise.all([
        this.$store.dispatch("question/getChildren"),
        this.$store.dispatch("question/getTeamHeight", this.user),
      ]);
      await Promise.all([
        this.$store.dispatch("question/getTeamAndCohort"),
        this.$store.dispatch("question/getUser"),
        this.$store.dispatch("question/getDataOrganize", {
          user: this.user,
        }),
      ]);
    },
    getLocalizedQuestionText(question) {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      // Check for selected language translation
      if (question.questions && question.questions[selectedLanguage]) {
        return question.questions[selectedLanguage];
      }
      
      // Fallback to English
      return question.question_en;
    },
    hasFollowUpQuestions(question) {
      // Check if question has follow-up questions assigned
      if (!question.m_choice) {
        return false;
      }
      
      // Check quest_id array for Yes/No questions
      if (question.m_choice.quest_id && Array.isArray(question.m_choice.quest_id)) {
        return question.m_choice.quest_id.some(id => id && id.trim() !== '');
      }
      
      // Check question_id field in options for Multiple Choice questions
      const languages = ['en', 'th', 'ms']; // Add other languages as needed
      for (const lang of languages) {
        if (question.m_choice[lang] && Array.isArray(question.m_choice[lang])) {
          for (const option of question.m_choice[lang]) {
            if (option && option.question_id && option.question_id.trim() !== '') {
              return true;
            }
          }
        }
      }
      
      return false;
    },
    getTeamNames(question) {
      const optionToName = this.$store.state.question.optionToName;
      const teamNames = [];
      
      if (!question.teams && !question.cohorts) {
        teamNames.push("All teams and cohorts");
      }
      
      if (question.teams) {
        question.teams.forEach(teamId => {
          teamNames.push(optionToName[teamId] || "[Archived Team]");
        });
      }
      
      if (question.cohorts) {
        question.cohorts.forEach(cohortId => {
          teamNames.push(optionToName[cohortId] || "[Archived Cohort]");
        });
      }
      
      return teamNames;
    },
    getFollowUpQuestionsText(question) {
      try {
        if (!question.m_choice) return [];
      
      // Get questions from both stores to ensure we have all available questions
      const standardQuestions = this.$store.state.question.questions || [];
      const customQuestions = this.$store.state.custom.questions || [];
      const allQuestions = [...standardQuestions, ...customQuestions];
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      const followUpMap = new Map(); // Use Map to group identical questions
      
      // Handle Yes/No questions (quest_id array)
      if (question.m_choice.quest_id && Array.isArray(question.m_choice.quest_id)) {
        // Get localized Yes/No labels
        const yesNoOptions = question.m_choice[selectedLanguage] || question.m_choice.en || ['No', 'Yes'];
        
        // Handle weight reversal
        let finalOptions = [...yesNoOptions];
        // if (question.m_choice.weight && (question.m_choice.weight[0] === "0" || question.m_choice.weight[0] === 0)) {
        //   finalOptions = [...yesNoOptions].reverse();
        // }
        
        question.m_choice.quest_id.forEach((id, index) => {
          if (id && id.trim() !== '') {
            const followUpQuestion = allQuestions.find(q => q.key === id);
            if (followUpQuestion) {
              const questionText = this.getLocalizedQuestionText(followUpQuestion);
              const optionText = finalOptions[index] || `Option ${index + 1}`;
              
              // Group identical questions
              if (followUpMap.has(questionText)) {
                followUpMap.get(questionText).options.push(optionText);
              } else {
                followUpMap.set(questionText, {
                  text: questionText,
                  options: [optionText]
                });
              }
            }
          }
        });
      }
      
      // Handle Multiple Choice questions (question_id in options)
      const optionLanguages = [selectedLanguage, 'en', 'th', 'ms'];
      for (const lang of optionLanguages) {
        if (question.m_choice[lang] && Array.isArray(question.m_choice[lang])) {
          question.m_choice[lang].forEach((option) => {
            if (option && option.question_id && option.question_id.trim() !== '') {
              const followUpQuestion = allQuestions.find(q => q.key === option.question_id);
              if (followUpQuestion) {
                const questionText = this.getLocalizedQuestionText(followUpQuestion);
                const optionText = option[selectedLanguage] || option.en || option.th || 'Option';
                
                // Group identical questions
                if (followUpMap.has(questionText)) {
                  followUpMap.get(questionText).options.push(optionText);
                } else {
                  followUpMap.set(questionText, {
                    text: questionText,
                    options: [optionText]
                  });
                }
              }
            }
          });
          break; // Only process first available language to avoid duplicates
        }
      }
      
      // Convert Map to array and remove duplicate options
      return Array.from(followUpMap.values()).map(item => ({
        text: item.text,
        options: [...new Set(item.options)] // Remove duplicate options
      }));
      } catch (error) {
        console.error('Error in getFollowUpQuestionsText:', error);
        return [];
      }
    },
    handleLanguageChange(langCode) {
      // Force component re-render when language changes
      this.$forceUpdate();
      
      // If a modal is open, refresh the question name
      if (this.currentQuestionData) {
        this.quest_name = this.getLocalizedQuestionText(this.currentQuestionData);
      }
    },
    getstylefollowUp(option) {
      if (option.question_id == '') {
        return 'background-color:#E0E0E0;color:black;'
      } else {
        return 'background-color:#6C30CC;color:white;'
      }
    },
    getActiveOptions() {
     
      if (this.activeIndex === 'en' || this.activeIndex === 'th'|| this.activeIndex === 'ms') {
      return this.dynamicValidateForm[`options_${this.activeIndex}`] || [];
    }
    if (!this.dynamicValidateForm.options_YN[this.activeIndex]) {
        this.$set(this.dynamicValidateForm.options_YN, this.activeIndex, [
          { key: 1, value: '', placeholder: 'Yes', question_id: '' },
          { key: 2, value: '', placeholder: 'No', question_id: '' },
        ]);
      }
      return this.dynamicValidateForm.options_YN[this.activeIndex];
    },
    
    isReadonly() {
      return this.activeIndex === 'en' || this.activeIndex === 'th';
    },
    updateOptionValue(index, value) {
      // console.log("updateOptionValue",this.dynamicValidateForm.options_YN[this.activeIndex][index].value)
      this.dynamicValidateForm.options_YN[this.activeIndex][index].value=value
      this.$forceUpdate(); // บังคับให้อัปเดต UI
    },
    
    // Badge styling methods
    getQuestionTypeBadgeClass(type) {
      const typeMap = {
        'Multiple Choice': 'badge-multiple-choice',
        'Multiple Choice(other)': 'badge-multiple-choice',
        'Yes/No': 'badge-yes-no',
        'Scale': 'badge-scale',
        'Text Area Field': 'badge-text-area',
        'Follow-up': 'badge-follow-up'
      };
      return typeMap[type] || 'badge-default';
    },
    
    getFrequencyTagClass(frequency) {
      if (!frequency) return '';
      const freq = frequency.toLowerCase();
      if (freq.includes('bi-annual')) return 'tag-biannual';
      if (freq.includes('year')) return 'tag-yearly';
      if (freq.includes('follow')) return 'tag-follow-up';
      return 'tag-default';
    },
    
    truncateText(text) {
      let length = this.maxLength;
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    openRecipientsDialog() {
      this.recipientsModal = true;
    },
    changeDataToCascader(value) {
      let recipients = [];
      let cascaderTo = [];
      let oldcascaderTo = [];
      let diffcascaderTo = {};
      let diffoldcascaderTo = {};

      let team = [];
      let alluser = _.find(
        this.dynamicValidateForm.cascaderTo,
        function (value) {
          return value[0] == "all_teams_and_cohorts";
        }
      );

      let oldalluser = _.find(
        this.dynamicValidateForm.oldCascaderTo,
        function (value) {
          return value[0] == "all_teams_and_cohorts";
        }
      );

      // if(oldalluser&&!alluser){
      //   this.dynamicValidateForm.cascaderTo=[[]]
      //   this.dynamicValidateForm.oldCascaderTo=[[]]
      //   this.dynamicValidateForm.recipients=[]
      // }

      // else
      if (alluser) {
        //this.dynamicValidateForm.cascaderTo=this.optionTo.map((row) => [row.value]);
        this.dynamicValidateForm.oldCascaderTo =
          this.dynamicValidateForm.cascaderTo;
        this.dynamicValidateForm.recipients = this.allUsers;
      } else {
        if (this.dynamicValidateForm.cascaderTo) {
          this.dynamicValidateForm.cascaderTo.map((value) => {
            cascaderTo.push(value[0]);
          });
        }
        if (this.dynamicValidateForm.oldCascaderTo) {
          this.dynamicValidateForm.oldCascaderTo.map((value) => {
            oldcascaderTo.push(value[0]);
          });
        }

        let diff = _.xor(cascaderTo, oldcascaderTo);

        if (diff) {
          diff.map((data) => {
            if (data) {
              let diffolddata = _.filter(
                this.dynamicValidateForm.oldCascaderTo,
                function (value) {
                  return value[0] == data;
                }
              );
              if (diffolddata[0]) {
                diffoldcascaderTo[diffolddata[0]] = true;
              }
            }
          });
        }

        //cohorts
        if (this.dynamicValidateForm.cascaderTo) {
          this.dynamicValidateForm.cascaderTo.map((value) => {
            if (
              this.cohortsUser[value[0]] &&
              this.cohortsUser[value[0]].users
            ) {
              team.push(value[0]);
              for (let data in this.cohortsUser[value[0]].users) {
                let user = _.find(this.allUsers, function (v) {
                  return v.key == data;
                });
                if (user) {
                  recipients.push(user);
                }
              }
              //cohorts=====================
            } else {
              if (this._organization1level[value]) {
                for (let teamId in this._organization1level[value]) {
                  if (!diffoldcascaderTo[teamId]) {
                    if (this.userTeam[teamId]) {
                      recipients.push(...this.userTeam[teamId]);
                    }
                    let uniq = _.find(team, function (value) {
                      return value == teamId;
                    });
                    if (!uniq) {
                      team.push(teamId);
                    }
                  }
                }
              } else {
                if (this.userTeam[value]) {
                  recipients.push(...this.userTeam[value]);
                }
                let uniq = _.find(team, function (value) {
                  return value == value;
                });
                if (!uniq) {
                  team.push(value);
                }
              }
            }
          });
        }

        // this.dynamicValidateForm.cascaderTo=this.optionTo.map((row) => {
        //           let uniq=_.find(team, function(value){
        //                       return value ==row.value;
        //             });
        //           if(uniq){
        //             return [row.value]
        //           }else{
        //             return []
        //           }

        // });
        recipients = _.uniqBy(recipients, "email");
        this.dynamicValidateForm.recipients = recipients;

        // this.dynamicValidateForm.cascaderTo=_.filter(this.dynamicValidateForm.cascaderTo, function(value){
        //                     return value[0] ;
        //     })
        this.dynamicValidateForm.oldCascaderTo =
          this.dynamicValidateForm.cascaderTo;
      }
    },
    filterToFunction(node, keyword) {
      const keywordArr = keyword.split(/, | /);
      if (keywordArr.length > 1) {
        for (let i = 0; i < keywordArr.length; i++) {
          const keywordTrim = keywordArr[i].trim();
          if (node.data.toType == "user") {
            if (
              node.data.firstname
                .toLowerCase()
                .indexOf(keywordTrim.toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (
              node.data.lastname
                .toLowerCase()
                .indexOf(keywordTrim.toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (keywordTrim.trim() === node.data.email) {
              this.dynamicValidateForm.cascaderTo.push([
                "user_" + node.data.email,
              ]);
              // this.changeDataTo(this.dynamicValidateForm.cascaderTo);
              this.refreshInput = false;
              setTimeout(() => {
                this.refreshInput = true;
              }, i * 75);
            }
          }
        }
        setTimeout(() => {
          this.$refs.refTo.inputValue = "";
          this.$refs.refTo.dropDownVisible = false;
        }, keywordArr.length * 75);
        this.$refs.refTo.handleClear();
      } else {
        if (node.data.toType == "user") {
          if (
            node.data.firstname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (
            node.data.lastname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (keyword.trim() === node.data.email) {
            this.dynamicValidateForm.cascaderTo.push([
              "user_" + node.data.email,
            ]);
            this.refreshInput = false;
            this.changeDataTo(this.dynamicValidateForm.cascaderTo);
            setTimeout(() => {
              this.refreshInput = true;
            }, 100);
            this.$refs.refTo.inputValue = "";
            this.$refs.refTo.dropDownVisible = false;
            this.$refs.refTo.handleClear();
          }
        } else {
          return (
            node
              .getText(false, null)
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
          );
        }
      }
    },
    increase(index) {
      return index + 1;
    },
    onChangeQuestionsType(value) {
      if(this.dynamicValidateForm.report_card == true){
        document.getElementById("report_card").click();
      }

      if(value == 'Text Area Field'){
        this.disabledRowHeader = true
      }else{
        this.disabledRowHeader = false
      }
    },
    onChangeY(value) {
      if (value === "Negative") {
        this.dynamicValidateForm.feelingN = "Positive";
      } else if (value === "Neutral") {
        this.dynamicValidateForm.feelingN = "Neutral";
      } else {
        this.dynamicValidateForm.feelingN = "Negative";
      }
    },
    onChangeN(value) {
      if (value === "Negative") {
        this.dynamicValidateForm.feelingY = "Positive";
      } else if (value === "Neutral") {
        this.dynamicValidateForm.feelingY = "Neutral";
      } else {
        this.dynamicValidateForm.feelingY = "Negative";
      }
    },
    addOptions() {
      if (this.dynamicValidateForm.options.length < 6) {
        if (this.dynamicValidateForm.options.length === 2) {
          this.dynamicValidateForm.options.push({
            key: this.$utils("mockingID", 15),
            feeling: "Negative",
            question_id:'',
          });
        } else {
          this.dynamicValidateForm.options.push({
            key: this.$utils("mockingID", 15),
            feeling: "",
            th: "",
            en: "",
            question_id:'',
          });
        }
      }
    },
    deleteOptions(value) {
      this.dynamicValidateForm.options = _.filter(
        this.dynamicValidateForm.options,
        function (currentObject) {
          return currentObject.key !== value.key;
        }
      );
    },
    getScalePercent(id, index) {
      if (this.datamultichoices[id]) {
        let total = 0;
        for (var i = 0; i < this.datamultichoices[id]["range"].length; i++) {
          total += this.datamultichoices[id]["range"][i];
        }
        if (total !== 0) {
          let results = Math.round(
            (this.datamultichoices[id]["range"][index] * 100) / total
          );
          return results;
        } else {
          return 0;
        }
      }
    },
    getColorPercentForScale(value) {
      if (value) {
        return `width: ${Math.round((537 / 100) * value)}px;`;
      } else {
        return;
      }
    },
    getYesPercent(id) {
      if (this.datamultichoices[id]) {
        const total =
          this.datamultichoices[id][0] + this.datamultichoices[id][1];
        if (total !== 0)
          return Math.round((this.datamultichoices[id][0] * 100) / total);
        else return 0;
      }
    },
    getNoPercent(id) {
      if (this.datamultichoices[id]) {
        const total =
          this.datamultichoices[id][0] + this.datamultichoices[id][1];
        if (total !== 0)
          return Math.round((this.datamultichoices[id][1] * 100) / total);
        else return 0;
      }
    },
    getMultipleChoicePercent(id, index) {
      if (this.datamultichoices[id]) {
        let total = 0;
        if (this.answerOpt.length > 0) {
          for (var i = 0; i < this.datamultichoices[id].length; i++) {
            total += this.datamultichoices[id][i];
          }
          if (total !== 0) {
            let results = Math.round(
              (this.datamultichoices[id][index] * 100) / total
            );
            return results;
          } else {
            return 0;
          }
        }
      }
    },
    getColorPercent(value) {
      if (value) {
        return `width: ${Math.round((577 / 100) * value)}px;`;
      } else {
        return;
      }
    },
    async openModal(elm) {
      this.quest_id = elm.key;
      this.quest_name = this.getLocalizedQuestionText(elm);
      this.currentQuestionData = elm; // Store current question data for localization
      await this.ensureQuestionDetailReady();
      this.$store.commit("question/setLoading", true);
      if (elm.type === "Multiple Choice") {
        if (elm.custom_type === "multiple_choice") {
          this.$store.commit("question/setCountMultiChoices", 0);
          this.$store.commit("question/setDataMultiChoices", []);
          this.dialogMultipleOther = true;
          this.$store.dispatch("question/getDateDetail", {
            quest_id: elm.key,
            type: elm.type,
            custom_type: elm.custom_type,
          });
        } else {
          if (elm.m_choice.weight[0] === "0" || elm.m_choice.weight[0] === 0) {
            this.yes = false;
          } else {
            this.yes = true;
          }
          this.$store.commit("question/setCountMultiChoices", 0);
          this.$store.commit("question/setDataMultiChoices", []);
          this.dialogYesNo = true;
          this.$store.dispatch("question/getDateDetail", {
            quest_id: elm.key,
            type: elm.type,
          });
        }
      } else if (elm.type === "Scale") {
        this.$store.commit("question/setCountMultiChoices", 0);
        this.$store.commit("question/setDataMultiChoices", []);
        this.dialogScale = true;
        this.$store.dispatch("question/getDateDetail", {
          quest_id: elm.key,
          type: elm.type,
        });
      } else {
        this.$store.commit("question/setDataOpenEnd", []);
        this.dialogOpenEnded = true;
        this.$store.dispatch("question/getDateDetail", {
          quest_id: elm.key,
          type: elm.type,
        });
      }
    },
    async handleEdit(index, item) {
      await this.ensureEditorMetadataReady();
      this.title_dialog = "Edit Question";
      this.dialogFormEdit = true;
      this.id = item.key;
      let schedule = "";
      let day = "";
      let option = [];
      if (item.repeats == "onetime") {
        let split = item.starton.split("/");
        day = format(new Date(split[2], split[1] - 1, split[0]), "dddd");
        day = day.toLowerCase();
        this.$store.dispatch("question/getScheduleOptions", {
          end_row: "",
          dayofweek: day,
        });
        schedule = format(
            new Date(split[2], split[1] - 1, split[0]),
            "dddd, MMMM D, YYYY"
          );//split[2] + "-" + split[1] + "-" + split[0];
        if (
          _.findKey(this.optionsScheduleOnetime, ["value", schedule]) ==
          undefined
        ) {
          let labelOpt = format(
            new Date(split[2], split[1] - 1, split[0]),
            "dddd, MMMM D, YYYY"
          );
          this.optionFirst = {
            label: labelOpt,
            value: schedule,
          };
          this.$store.commit(
            "question/setRemoveLastItem",
            this.optionsScheduleOnetime
          );
        }
      } else if (item.repeats == "weekly") {
        let dayKey = _.invert(item.repeat_days)["Y"];
        if (dayKey == "Mon") {
          schedule = "monday";
        } else if (dayKey == "Tue") {
          schedule = "tuesday";
        } else if (dayKey == "Wed") {
          schedule = "wednesday";
        } else if (dayKey == "Thu") {
          schedule = "thursday";
        } else if (dayKey == "Fri") {
          schedule = "friday";
        } else if (dayKey == "Sat") {
          schedule = "saturday";
        } else if (dayKey == "Sun") {
          schedule = "sunday";
        }
        day = schedule;
      } else if (item.repeats == "monthly") {
        let dayKey = _.invert(item.repeat_days)["Y"];
        if (dayKey == "Mon") {
          day = "monday";
        } else if (dayKey == "Tue") {
          day = "tuesday";
        } else if (dayKey == "Wed") {
          day = "wednesday";
        } else if (dayKey == "Thu") {
          day = "thursday";
        } else if (dayKey == "Fri") {
          day = "friday";
        } else if (dayKey == "Sat") {
          day = "saturday";
        } else if (dayKey == "Sun") {
          day = "sunday";
        }
        schedule = _.invert(item.repeat_weeks)["Y"];
      } else if (item.repeats == "quarterly") {
        let dayKey = _.invert(item.repeat_days)["Y"];
        if (dayKey == "Mon") {
          day = "monday";
        } else if (dayKey == "Tue") {
          day = "tuesday";
        } else if (dayKey == "Wed") {
          day = "wednesday";
        } else if (dayKey == "Thu") {
          day = "thursday";
        } else if (dayKey == "Fri") {
          day = "friday";
        } else if (dayKey == "Sat") {
          day = "saturday";
        } else if (dayKey == "Sun") {
          day = "sunday";
        }
        let dayName = day.charAt(0).toUpperCase() + day.slice(1);
        this.options_quarterly = [
          {
            label: "First month of the quarter",
            options: [
              {
                value: "1_week1",
                label:
                  "First " + dayName + " of the first month of the quarter",
              },
              {
                value: "1_week2",
                label:
                  "Second " + dayName + " of the first month of the quarter",
              },
              {
                value: "1_week3",
                label:
                  "Third " + dayName + " of the first month of the quarter",
              },
              {
                value: "1_week4",
                label:
                  "Fourth " + dayName + " of the first month of the quarter",
              },
            ],
          },
          {
            label: "Second month of the quarter",
            options: [
              {
                value: "2_week1",
                label:
                  "First " + dayName + " of the second month of the quarter",
              },
              {
                value: "2_week2",
                label:
                  "Second " + dayName + " of the second month of the quarter",
              },
              {
                value: "2_week3",
                label:
                  "Third " + dayName + " of the second month of the quarter",
              },
              {
                value: "2_week4",
                label:
                  "Fourth " + dayName + " of the second month of the quarter",
              },
            ],
          },
          {
            label: "Third month of the quarter",
            options: [
              {
                value: "3_week1",
                label:
                  "First " + dayName + " of the third month of the quarter",
              },
              {
                value: "3_week2",
                label:
                  "Second " + dayName + " of the third month of the quarter",
              },
              {
                value: "3_week3",
                label:
                  "Third " + dayName + " of the third month of the quarter",
              },
              {
                value: "3_week4",
                label:
                  "Fourth " + dayName + " of the third month of the quarter",
              },
            ],
          },
        ];
        let week = _.invert(item.repeat_weeks)["Y"];
        schedule = item.repeat_quarter + "_" + week;
      } else if (item.repeats == "biannually") {
        let dayKey = _.invert(item.repeat_days)["Y"];
        if (dayKey == "Mon") {
          day = "monday";
        } else if (dayKey == "Tue") {
          day = "tuesday";
        } else if (dayKey == "Wed") {
          day = "wednesday";
        } else if (dayKey == "Thu") {
          day = "thursday";
        } else if (dayKey == "Fri") {
          day = "friday";
        } else if (dayKey == "Sat") {
          day = "saturday";
        } else if (dayKey == "Sun") {
          day = "sunday";
        }
        let dayName = day.charAt(0).toUpperCase() + day.slice(1);
          this.options_biannually = [
          {
            label: "First month of the Q1 and Q3",
            options: [
              {
                value: "1_week1_q1_q3",
                label: "First " + dayName + " of the first month of Q1 and Q3",
              },{
                value: "1_week2_q1_q3",
                label: "Second " + dayName + " of the first month of Q1 and Q3",
              },{
                value: "1_week3_q1_q3",
                label: "Third " + dayName + " of the first month of Q1 and Q3",
              },{
                value: "1_week4_q1_q3",
                label: "Forth " + dayName + " of the first month of Q1 and Q3",
              },{
                value: "1_week5_q1_q3",
                label: "Fifth " + dayName + " of the first month of Q1 and Q3",
              },
            ],
          },{
            label: "Second month of the Q1 and Q3",
            options: [
              {
                value: "2_week1_q1_q3",
                label: "First " + dayName + " of the second month of Q1 and Q3",
              },{
                value: "2_week2_q1_q3",
                label: "Second " + dayName + " of the second month of Q1 and Q3",
              },{
                value: "2_week3_q1_q3",
                label: "Third " + dayName + " of the second month of Q1 and Q3",
              },{
                value: "2_week4_q1_q3",
                label: "Forth " + dayName + " of the second month of Q1 and Q3",
              },{
                value: "2_week5_q1_q3",
                label: "Fifth " + dayName + " of the second month of Q1 and Q3",
              },
            ],
          },{
            label: "Third month of the Q1 and Q3",
            options: [
              {
                value: "3_week1_q1_q3",
                label: "First " + dayName + " of the third month of Q1 and Q3",
              },{
                value: "3_week2_q1_q3",
                label: "Second " + dayName + " of the third month of Q1 and Q3",
              },{
                value: "3_week3_q1_q3",
                label: "Third " + dayName + " of the third month of Q1 and Q3",
              },{
                value: "3_week4_q1_q3",
                label: "Forth " + dayName + " of the third month of Q1 and Q3",
              },{
                value: "3_week5_q1_q3",
                label: "Fifth " + dayName + " of the third month of Q1 and Q3",
              },
            ],
          },{
            label: "First month of the Q2 and Q4",
            options: [
              {
                value: "1_week1_q2_q4",
                label: "First " + dayName + " of the first month of Q2 and Q4",
              },{
                value: "1_week2_q2_q4",
                label: "Second " + dayName + " of the first month of Q2 and Q4",
              },{
                value: "1_week3_q2_q4",
                label: "Third " + dayName + " of the first month of Q2 and Q4",
              },{
                value: "1_week4_q2_q4",
                label: "Forth " + dayName + " of the first month of Q2 and Q4",
              },{
                value: "1_week5_q2_q4",
                label: "Fifth " + dayName + " of the first month of Q2 and Q4",
              },
            ],
          },{
            label: "Second month of the Q2 and Q4",
            options: [
              {
                value: "2_week1_q2_q4",
                label: "First " + dayName + " of the second month of Q2 and Q4",
              },{
                value: "2_week2_q2_q4",
                label: "Second " + dayName + " of the second month of Q2 and Q4",
              },{
                value: "2_week3_q2_q4",
                label: "Third " + dayName + " of the second month of Q2 and Q4",
              },{
                value: "2_week4_q2_q4",
                label: "Forth " + dayName + " of the second month of Q2 and Q4",
              },{
                value: "2_week5_q2_q4",
                label: "Fifth " + dayName + " of the second month of Q2 and Q4",
              },
            ],
          },{
            label: "Third month of the Q2 and Q4",
            options: [
              {
                value: "3_week1_q2_q4",
                label: "First " + dayName + " of the third month of Q2 and Q4",
              },{
                value: "3_week2_q2_q4",
                label: "Second " + dayName + " of the third month of Q2 and Q4",
              },{
                value: "3_week3_q2_q4",
                label: "Third " + dayName + " of the third month of Q2 and Q4",
              },{
                value: "3_week4_q2_q4",
                label: "Forth " + dayName + " of the third month of Q2 and Q4",
              },{
                value: "3_week5_q2_q4",
                label: "Fifth " + dayName + " of the third month of Q2 and Q4",
              },
            ],
          },
        ];
        let week = _.invert(item.repeat_weeks)["Y"];
        let quarter = []
        if(item.repeat_quarters['Q1'] == 'Y'){
          quarter.push('q1')
        }else if(item.repeat_quarters['Q2'] == 'Y'){
          quarter.push('q2')
        }
        if(item.repeat_quarters['Q3'] == 'Y'){
          quarter.push('q3')
        }else if(item.repeat_quarters['Q4'] == 'Y'){
          quarter.push('q4')
        }
        schedule = item.repeat_quarter + "_" + week + "_" + quarter[0] + "_" + quarter[1];
      } else if (item.repeats == "yearly") {
        let dayKey = _.invert(item.repeat_days)["Y"];
        if (dayKey == "Mon") {
          day = "monday";
        } else if (dayKey == "Tue") {
          day = "tuesday";
        } else if (dayKey == "Wed") {
          day = "wednesday";
        } else if (dayKey == "Thu") {
          day = "thursday";
        } else if (dayKey == "Fri") {
          day = "friday";
        } else if (dayKey == "Sat") {
          day = "saturday";
        } else if (dayKey == "Sun") {
          day = "sunday";
        }
        let dayName = day.charAt(0).toUpperCase() + day.slice(1);
        this.options_yearly = []
        for(let i = 1; i < 13; i++){
          let month = format(`2023-${i}-01`, 'MMMM')
          this.options_yearly.push({
            label: month,
            options: [
              {
                value: month + "_week1",
                label: "First " + dayName + " of " + month,
              },{
                value: month + "_week2",
                label: "Second " + dayName + " of " + month,
              },{
                value: month + "_week3",
                label: "Third " + dayName + " of " + month,
              },{
                value: month + "_week4",
                label: "Forth " + dayName + " of " + month,
              },{
                value: month + "_week5",
                label: "Fifth " + dayName + " of " + month,
              },
            ],
          })
        }
        let week = _.invert(item.repeat_weeks)["Y"];
        let nameMonth = item.repeat_months
        schedule = nameMonth + "_" + week;
      } 
      const lang={}
      for(const i in this.language){
          if(!lang[this.language[i].code]){
            lang[this.language[i].code]=''
          }
      }
      if (item.custom_type == "multiple_choice") {
       
        item.m_choice.en.map((value, i) => {
          for(const key in lang){
       
              if(item.m_choice[key]&&item.m_choice[key][i]){
                lang[key]=item.m_choice[key]?item.m_choice[key][i]:''
              }
          }
         
          option.push({
            ...lang,
            key: this.$utils("mockingID", 15),
            th: item.m_choice.th[i],
            en: value,
            feeling: item.m_choice.feeling[i],
            question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[i]:'',
          });
        });
        
      } else {
        option = [
          {
            ...lang,
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Positive",
            question_id:'',
          },
          {
            ...lang,
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Neutral",
            question_id:'',
          },
          {
            ...lang,
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Negative",
            question_id:'',
          },
        ];
      }


     
       
      
      let cascaderTo = [];
      if (!item.teams && !item.cohorts) {
        cascaderTo.push(["all_teams_and_cohorts"]);
      } else {
        if (item.teams) {
          item.teams.map((value) => {
            cascaderTo.push([value]);
          });
        }
        if (item.cohorts) {
          item.cohorts.map((value) => {
            cascaderTo.push([value]);
          });
        }
      }
      this.dynamicValidateForm = {
        cascaderTo: cascaderTo,
        showResultsInDaily: item&&item.collect_anonymous_feedback ? item.collect_anonymous_feedback==true?false:true : true,
        category: item.category,
        type:
          item.custom_type == "multiple_choice"
            ? "Multiple Choice(other)"
            : item.type,
        question_en: item.question_en,
        question_th: item.question,
        questions:item.questions,
        coins:
          item.type == "Multiple Choice" ||
          item.type == "Multiple Choice(other)"
            ? item.m_choice.points[0]
            : item.points,
        frequency: item.repeats,
        schedule: schedule,
        status: item.status,
        feelingY: item.custom_type == "yes_no" ? item.m_choice.feeling[0] : "",
        feelingN: item.custom_type == "yes_no" ? item.m_choice.feeling[1] : "",
        options_YN:{},
        options_en: [
          { key: 1, value: "Yes", weight: "1", placeholder: "Yes",question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[0]:''},
          { key: 2, value: "No", weight: "0", placeholder: "No",question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[1]:'' },
        ],
        options_th: [
          { key: 1, value: "ใช่", placeholder: "Yes",question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[0]:'' },
          { key: 2, value: "ไม่ใช่", placeholder: "No",question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[1]:'' },
        ],
        options: option,
        dayofweek: day,
        less_txts: item.less_txts,
        less_txt: item.less_txt,
        less_txt_en: item.less_txt_en,
        max_txts: item.max_txts,
        max_txt: item.max_txt,
        max_txt_en: item.max_txt_en,
        custom_type: item.custom_type,
        powerSkill: item.powerSkill,
        max: 10,
        min: 0,
        rolling:item.rolling,
        report_card: (item.report_card && item.report_card == 'Y') ? true : false,
        report_card_label: item.report_card_label ? item.report_card_label : '',
        culture_index: item.culture_index ? item.culture_index : false
      };
     
      
      if(item.custom_type == "yes_no"){
        for(const key in lang){
          if(key!='en'&&key!='th'){
   
              const arr=[
                { key: 1, value: item.m_choice[key]?item.m_choice[key][0]:'', placeholder: 'Yes', question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[0]:'' },
                { key: 2, value: item.m_choice[key]?item.m_choice[key][1]:'', placeholder: 'No', question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[1]:'' },
              ]
              if(this.dynamicValidateForm.options_YN&&!this.dynamicValidateForm.options_YN[key]){
                this.dynamicValidateForm.options_YN[key]=JSON.parse(JSON.stringify(arr));
                this.dynamicValidateForm[`options_${key}`]=JSON.parse(JSON.stringify(arr));
              //   this.$set(this.dynamicValidateForm.options_YN, key, [
              //   { key: 1, value: item.m_choice[key]?item.m_choice[key][0]:'', placeholder: 'Yes', question_id: '' },
              //   { key: 2, value: item.m_choice[key]?item.m_choice[key][1]:'', placeholder: 'No', question_id: '' },
              // ]);
              }
              
          }
        }
     

      }

     
      if(item.frequency == "Follow-up"){
        this.dynamicValidateForm.frequency = item.frequency
      }
      if(item.type == 'Text Area Field'){
        this.disabledRowHeader = true
      }else{
        this.disabledRowHeader = false
      }
      if(item.report_card_label){
        this.$store.commit("question/setRowHeader", item.report_card_label);
      }else{
        this.$store.commit("question/setRowHeader", '');
      }

      //console.log('this.dynamicValidateForm',this.dynamicValidateForm)  
      this.changeDataToCascader();
    },
    handleBlock(item) {
      if (item.block_status === false) {
        this.$store.dispatch("custom/blockQuestion", item.key);
      } else {
        this.$store.dispatch("custom/unblockQuestion", item.key);
      }
    },
    statusClick(type) {
      const opt = [];
      opt["Active"] = "N";
      opt["Inactive"] = "Y";
      opt["Show All"] = "all";
      this.selectStatus = type;
      this.status = opt[type];
      this.$store.commit("custom/setselectShow", { type: opt[type] });
      this.$store.dispatch("custom/selectStatus", this.status);
    },
    cancelDialogEdit() {
      this.dialogFormEdit = false;
      this.optionFirst = {};
      this.$refs["dynamicValidateForm"].clearValidate();
      this.$store.commit("question/setPageOT", 1);
      this.$store.dispatch("question/getScheduleOptions", { end_row: "" });
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    scheduleChange(val) {
      if (this.dynamicValidateForm.frequency == "onetime") {
        this.$store.dispatch("question/getScheduleOptions", {
          end_row: "",
          dayofweek: this.dynamicValidateForm.dayofweek,
        });
        this.dynamicValidateForm.schedule = "";
      } else if (this.dynamicValidateForm.frequency == "weekly") {
        this.dynamicValidateForm.schedule = this.dynamicValidateForm.dayofweek;
      } else if (this.dynamicValidateForm.frequency == "monthly") {
        this.dynamicValidateForm.schedule = "";
      } else if (this.dynamicValidateForm.frequency == "quarterly") {
        let day =
          this.dynamicValidateForm.dayofweek.charAt(0).toUpperCase() +
          this.dynamicValidateForm.dayofweek.slice(1);
        this.options_quarterly = [
          {
            label: "First month of the quarter",
            options: [
              {
                value: "1_week1",
                label: "First " + day + " of the first month of the quarter",
              },
              {
                value: "1_week2",
                label: "Second " + day + " of the first month of the quarter",
              },
              {
                value: "1_week3",
                label: "Third " + day + " of the first month of the quarter",
              },
              {
                value: "1_week4",
                label: "Fourth " + day + " of the first month of the quarter",
              },
            ],
          },
          {
            label: "Second month of the quarter",
            options: [
              {
                value: "2_week1",
                label: "First " + day + " of the second month of the quarter",
              },
              {
                value: "2_week2",
                label: "Second " + day + " of the second month of the quarter",
              },
              {
                value: "2_week3",
                label: "Third " + day + " of the second month of the quarter",
              },
              {
                value: "2_week4",
                label: "Fourth " + day + " of the second month of the quarter",
              },
            ],
          },
          {
            label: "Third month of the quarter",
            options: [
              {
                value: "3_week1",
                label: "First " + day + " of the third month of the quarter",
              },
              {
                value: "3_week2",
                label: "Second " + day + " of the third month of the quarter",
              },
              {
                value: "3_week3",
                label: "Third " + day + " of the third month of the quarter",
              },
              {
                value: "3_week4",
                label: "Fourth " + day + " of the third month of the quarter",
              },
            ],
          },
        ];
        this.dynamicValidateForm.schedule = "";
      } else if (this.dynamicValidateForm.frequency == "biannually") {
        let day =
          this.dynamicValidateForm.dayofweek.charAt(0).toUpperCase() +
          this.dynamicValidateForm.dayofweek.slice(1);
          this.options_biannually = [
          {
            label: "First month of the Q1 and Q3",
            options: [
              {
                value: "1_week1_q1_q3",
                label: "First " + day + " of the first month of Q1 and Q3",
              },{
                value: "1_week2_q1_q3",
                label: "Second " + day + " of the first month of Q1 and Q3",
              },{
                value: "1_week3_q1_q3",
                label: "Third " + day + " of the first month of Q1 and Q3",
              },{
                value: "1_week4_q1_q3",
                label: "Forth " + day + " of the first month of Q1 and Q3",
              },{
                value: "1_week5_q1_q3",
                label: "Fifth " + day + " of the first month of Q1 and Q3",
              },
            ],
          },{
            label: "Second month of the Q1 and Q3",
            options: [
              {
                value: "2_week1_q1_q3",
                label: "First " + day + " of the second month of Q1 and Q3",
              },{
                value: "2_week2_q1_q3",
                label: "Second " + day + " of the second month of Q1 and Q3",
              },{
                value: "2_week3_q1_q3",
                label: "Third " + day + " of the second month of Q1 and Q3",
              },{
                value: "2_week4_q1_q3",
                label: "Forth " + day + " of the second month of Q1 and Q3",
              },{
                value: "2_week5_q1_q3",
                label: "Fifth " + day + " of the second month of Q1 and Q3",
              },
            ],
          },{
            label: "Third month of the Q1 and Q3",
            options: [
              {
                value: "3_week1_q1_q3",
                label: "First " + day + " of the third month of Q1 and Q3",
              },{
                value: "3_week2_q1_q3",
                label: "Second " + day + " of the third month of Q1 and Q3",
              },{
                value: "3_week3_q1_q3",
                label: "Third " + day + " of the third month of Q1 and Q3",
              },{
                value: "3_week4_q1_q3",
                label: "Forth " + day + " of the third month of Q1 and Q3",
              },{
                value: "3_week5_q1_q3",
                label: "Fifth " + day + " of the third month of Q1 and Q3",
              },
            ],
          },{
            label: "First month of the Q2 and Q4",
            options: [
              {
                value: "1_week1_q2_q4",
                label: "First " + day + " of the first month of Q2 and Q4",
              },{
                value: "1_week2_q2_q4",
                label: "Second " + day + " of the first month of Q2 and Q4",
              },{
                value: "1_week3_q2_q4",
                label: "Third " + day + " of the first month of Q2 and Q4",
              },{
                value: "1_week4_q2_q4",
                label: "Forth " + day + " of the first month of Q2 and Q4",
              },{
                value: "1_week5_q2_q4",
                label: "Fifth " + day + " of the first month of Q2 and Q4",
              },
            ],
          },{
            label: "Second month of the Q2 and Q4",
            options: [
              {
                value: "2_week1_q2_q4",
                label: "First " + day + " of the second month of Q2 and Q4",
              },{
                value: "2_week2_q2_q4",
                label: "Second " + day + " of the second month of Q2 and Q4",
              },{
                value: "2_week3_q2_q4",
                label: "Third " + day + " of the second month of Q2 and Q4",
              },{
                value: "2_week4_q2_q4",
                label: "Forth " + day + " of the second month of Q2 and Q4",
              },{
                value: "2_week5_q2_q4",
                label: "Fifth " + day + " of the second month of Q2 and Q4",
              },
            ],
          },{
            label: "Third month of the Q2 and Q4",
            options: [
              {
                value: "3_week1_q2_q4",
                label: "First " + day + " of the third month of Q2 and Q4",
              },{
                value: "3_week2_q2_q4",
                label: "Second " + day + " of the third month of Q2 and Q4",
              },{
                value: "3_week3_q2_q4",
                label: "Third " + day + " of the third month of Q2 and Q4",
              },{
                value: "3_week4_q2_q4",
                label: "Forth " + day + " of the third month of Q2 and Q4",
              },{
                value: "3_week5_q2_q4",
                label: "Fifth " + day + " of the third month of Q2 and Q4",
              },
            ],
          },
        ]
        this.dynamicValidateForm.schedule = "";
      } else if (this.dynamicValidateForm.frequency == "yearly") {
        let day =
        this.dynamicValidateForm.dayofweek.charAt(0).toUpperCase() +
        this.dynamicValidateForm.dayofweek.slice(1);
        this.options_yearly = []
        for(let i = 1; i < 13; i++){
          let month = format(`2023-${i}-01`, 'MMMM')
          this.options_yearly.push({
            label: month,
            options: [
              {
                value: month + "_week1",
                label: "First " + day + " of " + month,
              },{
                value: month + "_week2",
                label: "Second " + day + " of " + month,
              },{
                value: month + "_week3",
                label: "Third " + day + " of " + month,
              },{
                value: month + "_week4",
                label: "Forth " + day + " of " + month,
              },{
                value: month + "_week5",
                label: "Fifth " + day + " of " + month,
              },
            ],
          })
        }
        this.dynamicValidateForm.schedule = "";
      }
    },
    saveQuestion() {
      var option_other = [];
      if(this.dynamicValidateForm.report_card == true) {
        if(!this.dynamicValidateForm.report_card_label.replace(/ /g, "")){
          this.$message({
            showClose: true,
            message: "Please include a Row Header for your question",
            type: "error",
          });
          return false;
        }
      }
      if (this.dynamicValidateForm.type === "Multiple Choice(other)") {
        for(const i in this.dynamicValidateForm.options){
          // console.log('i',i)
          // console.log('this.dynamicValidateForm.options[i]',this.dynamicValidateForm.options[i])
          for(const j in this.language){
            if(this.dynamicValidateForm.options[i][this.language[j].code]){
              if(!this.dynamicValidateForm.options[i][this.language[j].code].replace(/ /g, "")){
                this.$message({
                  showClose: true,
                  message: `Please input Option ${this.language[j].text}`,
                  type: "error",
                });
                return false;
              }
            }else{
              this.$message({
                showClose: true,
                message: `Please input Option ${this.language[j].text}`,
                type: "error",
              });
              return false;
            }

          }
        }
      }

      // if (
      //   !this.engonly &&
      //   (!this.dynamicValidateForm.category.replace(/ /g, "") ||
      //     !this.dynamicValidateForm.type.replace(/ /g, "") ||
      //     !this.dynamicValidateForm.question_en.replace(/ /g, "") ||
      //     !this.dynamicValidateForm.question_th.replace(/ /g, "") ||
      //     !this.dynamicValidateForm.coins.replace(/ /g, "") ||
      //     !this.dynamicValidateForm.frequency.replace(/ /g, "") ||
      //     !this.dynamicValidateForm.dayofweek.replace(/ /g, "") ||
      //     !this.dynamicValidateForm.schedule.replace(/ /g, "") ||
      //     option_other.length > 0)
      // ) {
      //   this.$message({
      //     showClose: true,
      //     message: "Please include a Thai version for your question",
      //     type: "error",
      //   });
      //   return false;
      // } 
      if(this.dynamicValidateForm.questions){
        for(const i in this.language){

        if ( !this.dynamicValidateForm.questions[this.language[i].code] || 
        !this.dynamicValidateForm.questions[this.language[i].code].trim()) {
          this.$message({
            showClose: true,
            message: `Please include a ${this.language[i].text} version for your question`,
            type: "error",
          });
          return false;
        }
        }

      }
      if (!this.dynamicValidateForm.category.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Please select Dimension",
          type: "error",
        });
        return false;
      } else if (!this.dynamicValidateForm.type.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Please select Question Format",
          type: "error",
        });
        return false;
      } 
      // else if (!this.dynamicValidateForm.question_en.replace(/ /g, "")) {
      //   this.$message({
      //     showClose: true,
      //     message: "Please input question",
      //     type: "error",
      //   });
      //   return false;
      // } else if (!this.engonly &&(!this.dynamicValidateForm.question_th.replace(/ /g, ""))) {
      //   this.$message({
      //     showClose: true,
      //     message: "Please include a Thai version for your question",
      //     type: "error",
      //   });
      //   return false;
      // } 
      else if (!this.dynamicValidateForm.coins.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Please input Coins",
          type: "error",
        });
        return false;
      } else if (!this.dynamicValidateForm.frequency.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Please select Frequency",
          type: "error",
        });
        return false;
      } else if (!this.dynamicValidateForm.dayofweek.replace(/ /g, "")&&!this.dynamicValidateForm.frequency=='Follow-up') {
        this.$message({
          showClose: true,
          message: "Please select Day of Week",
          type: "error",
        });
        return false;
      } else if (!this.dynamicValidateForm.schedule.replace(/ /g, "")&&!this.dynamicValidateForm.frequency=='Follow-up') {
        this.$message({
          showClose: true,
          message: "Please select Schedule",
          type: "error",
        });
        return false;
      } else if (option_other.length < 0) {
        this.$message({
          showClose: true,
          message: "Please input Option",
          type: "error",
        });
        return false;
      } else if (this.dynamicValidateForm.type === "Multiple Choice") {
        if (
          (this.dynamicValidateForm.feelingY == "Positive" &&
            this.dynamicValidateForm.feelingN == "Negative") ||
          (this.dynamicValidateForm.feelingY == "Negative" &&
            this.dynamicValidateForm.feelingN == "Positive") ||
          (this.dynamicValidateForm.feelingY == "Neutral" &&
            this.dynamicValidateForm.feelingN == "Neutral")
        ) {
          const data = this.dynamicValidateForm;
          data["key"] = this.id;
      
          this.$store.dispatch("custom/CreateUpdateQuestion", {
            form: data,
          });
          this.cancelAdd();
          this.$message({
            type: "success",
            message: "Your custom question has been created",
          });
        } else {
          this.$message({
            showClose: true,
            message:
              'Yes or No questions must have either a Positive & Negative assignment to either "Yes" or "No" options OR a Neutral assignment for both options.',
            type: "error",
          });
          return false;
        }
      } else if (this.dynamicValidateForm.type === "Multiple Choice(other)") {
        var negative = _.filter(
          this.dynamicValidateForm.options,
          function (currentObject) {
            return currentObject.feeling === "Negative";
          }
        );
        var positive = _.filter(
          this.dynamicValidateForm.options,
          function (currentObject) {
            return currentObject.feeling === "Positive";
          }
        );
        var neutral = _.filter(
          this.dynamicValidateForm.options,
          function (currentObject) {
            return currentObject.feeling === "Neutral";
          }
        );
        var feelingisEmtry = _.filter(
          this.dynamicValidateForm.options,
          function (currentObject) {
            return !currentObject.feeling.replace(/ /g, "");
          }
        );
        if (feelingisEmtry.length > 0) {
          this.$message({
            showClose: true,
            message:
              "Multiple choice questions must have at least one Positive & one Negative assignment OR a Neutral assignment for all options.",
            type: "error",
          });
          return false;
        } else {
          if (
            neutral.length === this.dynamicValidateForm.options.length &&
            neutral.length > 0
          ) {
            const data = this.dynamicValidateForm;
            data["key"] = this.id;
            this.$store.dispatch("custom/CreateUpdateQuestion", {
              form: data,
            });
            this.cancelAdd();
            this.$message({
              type: "success",
              message: "Your custom question has been created",
            });
          } else if (positive.length > 0 && negative.length > 0) {
            const data = this.dynamicValidateForm;
            data["key"] = this.id;
            this.$store.dispatch("custom/CreateUpdateQuestion", {
              form: data,
            });
            this.cancelAdd();
            this.$message({
              type: "success",
              message: "Your custom question has been created",
            });
          } else {
            this.$message({
              showClose: true,
              message:
                "Multiple choice questions must have at least one Positive & one Negative assignment OR a Neutral assignment for all options.",
              type: "error",
            });
            return false;
          }
        }
      } else if (this.dynamicValidateForm.type === "Scale") {
        for(const i in this.language){
          
          if (!this.dynamicValidateForm.less_txts[this.language[i].code] || 
          !this.dynamicValidateForm.less_txts[this.language[i].code].trim()||
          !this.dynamicValidateForm.max_txts[this.language[i].code] || 
          !this.dynamicValidateForm.max_txts[this.language[i].code].trim()){
            this.$message({
            showClose: true,
            message: "Please input min/max Label",
            type: "error",
            });
            return false;
          }
        }
          const data = this.dynamicValidateForm;
          data["key"] = this.id;
          this.$store.dispatch("custom/CreateUpdateQuestion", {
            form: data,
          });
          this.cancelAdd();
          this.$message({
            type: "success",
            message: "Your custom question has been created",
          });
        
        
      } else {
        const data = this.dynamicValidateForm;
        data["key"] = this.id;
        this.$store.dispatch("custom/CreateUpdateQuestion", {
          form: data,
        });
        this.cancelAdd();
        this.$message({
          type: "success",
          message: "Your custom question has been created",
        });
      }
    },
    generateRowHeader(form){
      if(form.report_card == true){
        this.$store.dispatch("question/generateRowHeader", form);
      }
    },
    deleteQuestion() {
      this.$confirm(
        `Are you sure you want to delete this question? Any responses collected from this question will also be deleted.`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Sure",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("custom/deleteQuestion", this.id);
          this.$message({
            type: "success",
            message: "Delete question completed",
          });
          this.dialogFormEdit = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete question canceled",
          });
        });
    },
    cancelAdd() {
      this.dialogFormEdit = false;
      this.activeIndex = "en";
      this.dynamicValidateForm = {
        to: [],
        cascaderTo:this.teamleadership!=''?[this.teamleadership]:[["all_teams_and_cohorts"]],
        oldCascaderTo:this.teamleadership!=''?[this.teamleadership]:[["all_teams_and_cohorts"]],
        showResultsInDaily: true,
        category: "",
        type: "",
        questions:{},
        question_en: "",
        question_th: "",
        coins: "1",
        frequency: "",
        dayofweek: "monday",
        schedule: "",
        status: "Y",
        feelingY: "Positive",
        feelingN: "Negative",
        options_YN:{},
        options_en: [
          {
            key: 1,
            value: "Yes",
            weight: "1",
            placeholder: "Yes",
            question_id:''
          },
          {
            key: 2,
            value: "No",
            weight: "0",
            placeholder: "No",
            question_id:''
          },
        ],
        options_th: [
          {
            key: 1,
            value: "ใช่",
            placeholder: "Yes",
            question_id:''
          },
          {
            key: 2,
            value: "ไม่ใช่",
            placeholder: "No",
            question_id:''
          },
        ],
        options: [
          {
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Positive",
            question_id:''
          },
          {
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Neutral",
            question_id:''
          },
          {
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Negative",
            question_id:''
          },
        ],
        less_txt: "",
        less_txts: {},
        less_txt_en: "",
        max_txts:{},
        max_txt: "",
        max_txt_en: "",
        max: 10,
        min: 0,
        rolling:false,
        report_card: false,
        report_card_label: ""
      };
      if(this.language.length>0){
        for(const i in this.language){
     
          if(this.dynamicValidateForm.options_YN&&!this.dynamicValidateForm.options_YN[`${this.language[i].code}`]&&this.language[i].code!='en'&&this.language[i].code!='th'){
          const arr=[
          {
            key: 1,
            value: "",
            placeholder: "Yes",
            question_id:'',
          },
          {
            key: 2,
            value: "",
            placeholder: "No",
            question_id:'',
          },
        ]
        this.dynamicValidateForm[`options_${this.language[i].code}`]=JSON.parse(JSON.stringify(arr));
        this.dynamicValidateForm.options_YN[`${this.language[i].code}`]=JSON.parse(JSON.stringify(arr));
        }
      }

      }
      this.disabledRowHeader = true
    },
    moreOptionClick() {
      this.$store.dispatch("question/nextOnetimeSchedule", {
        dayofweek: this.dynamicValidateForm.dayofweek,
      });
      if (this.optionFirst.value) {
        if (
          _.findKey(this.optionsScheduleOnetime, [
            "value",
            this.optionFirst.value,
          ])
        ) {
          this.optionFirst = {};
        } else {
          this.$store.commit(
            "question/setRemoveLastItem",
            this.optionsScheduleOnetime
          );
        }
      }
    },
    renderDropdown() {
      if (this.dateoptions.length > 1) {
        return (
          <i
            style="margin-left: 16px; color: #000000;"
            class="el-icon-arrow-down"
          ></i>
        );
      }
    },
    renderHeaderOpenEnded(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      let countMessage = this.dataopenend.length;
      if(countMessage && countMessage > 0 && this.summaryDetail.Summary){
        countMessage = countMessage - 1
      }
      
      // Use filtered data for count when team filter is applied
      if (this.selectedTeamFilter !== 'all') {
        countMessage = this.filteredDataOpenEnd.filter(item => !item.Summary).length;
      }
      
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      return (
        <div class="headerOpenEnded">
          <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
            <span class="txtDropdown">
              {this.dateShow}
              {this.renderDropdown()}
            </span>

            <el-dropdown-menu slot="dropdown">
              <div style="max-height: 200px; width: 200px; overflow:auto;">
                {components}
              </div>
            </el-dropdown-menu>
          </el-dropdown>

          <span class="txtTotalResponse">
            {countMessage} {responses}
            {this.selectedTeamFilter !== 'all' && <span class="filtered-indicator"> (filtered)</span>}
          </span>
        </div>
      );
    },
    renderHeaderYesNo(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      const countMessage = this.countmultichoices;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      let classForNo = !this.yes ? "box color-4 mr-8" : "box color-2 mr-8";
      let classForYes = this.yes ? "box color-4 mr-8" : "box color-2 mr-8";
      return (
        <div>
          <div class="headerYesNo">
            <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
              <span class="txtDropdown">
                {this.dateShow}
                {this.renderDropdown()}
              </span>

              <el-dropdown-menu slot="dropdown">
                <div style="max-height: 200px; width: 200px; overflow:auto;">
                  {components}
                </div>
              </el-dropdown-menu>
            </el-dropdown>

            <span class="txtTotalResponse">
              {countMessage} {responses}
            </span>
          </div>
          <div>
            <div class="right flex-reverse fs-12 mt-10">
              <div class="flex ml-20">
                <div class={classForYes}></div>
                <div>{this.localizedAnswerOptions[0] || 'Yes'}</div>
              </div>
              <div class="flex ml-20">
                <div class={classForNo}></div>
                <div>{this.localizedAnswerOptions[1] || 'No'}</div>
              </div>
            </div>
          </div>
        </div>
      );
    },
    getMultipleChoiceColor(index) {
      if (this.answerOpt.length > 0) {
        let orderColor = [];
        if (this.answerOpt.length == 2) {
          orderColor = [2, 4];
        } else if (this.answerOpt.length == 3) {
          orderColor = [2, 3, 4];
        } else if (this.answerOpt.length == 4) {
          orderColor = [2, 3, 4, 5];
        } else {
          let no = 1;
          for (var i = 0; i < this.answerOpt.length; i++) {
            orderColor.push(no);
            no = no + 1;
          }
        }
        return orderColor[index];
      }
    },
    getScaleColor(index) {
      let orderColor = [2, 3, 4];
      return orderColor[index];
    },
    getScaleWidth(id) {
      if (this.datamultichoices[id]) {
        return `width: ${Math.round(
          (537 / 10) * this.datamultichoices[id].avg
        )}px;`;
      }
    },
    renderHeaderScale(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      const countMessage = this.countmultichoices;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      return (
        <div>
          <div class="flex-between mt-10 mb-2">
            <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
              <span class="txtDropdown">
                {this.dateShow}
                {this.renderDropdown()}
              </span>
              <el-dropdown-menu slot="dropdown">
                <div style="max-height: 200px; width: 200px; overflow:auto;">
                  {components}
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="txtTotalResponse">
              {this.$utils("addCommasInNumber", countMessage)} {responses}
            </span>
          </div>
          <div>
            <div class="right flex-reverse fs-13 mt-10">
              <div class="flex ml-20">
                <div class="box color-4 mr-8"></div>
                <div class="fc-000000 opa-06">9-10</div>
              </div>
              <div class="flex ml-20">
                <div class="box color-3 mr-8"></div>
                <div class="fc-000000 opa-06">7-8</div>
              </div>
              <div class="flex ml-20">
                <div class="box color-2 mr-8"></div>
                <div class="fc-000000 opa-06">0-6</div>
              </div>
            </div>
          </div>
        </div>
      );
    },
    renderHeaderMultipleOther(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      const countMessage = this.countmultichoices;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      let components_answer = [];
      if (this.localizedAnswerOptionsOther.length > 0) {
        let orderColor = [];
        if (this.localizedAnswerOptionsOther.length == 2) {
          orderColor = [4, 2];
        } else if (this.localizedAnswerOptionsOther.length == 3) {
          orderColor = [4, 3, 2];
        } else if (this.localizedAnswerOptionsOther.length == 4) {
          orderColor = [5, 4, 3, 2];
        } else {
          let no = this.localizedAnswerOptionsOther.length;
          for (var i = this.localizedAnswerOptionsOther.length; i > 0; i--) {
            orderColor.push(no);
            no = no - 1;
          }
        }
        for (var i = 0; i < this.localizedAnswerOptionsOther.length; i++) {
          components_answer.push(
            <div class="flex ml-20">
              <div class={"box color-" + orderColor[i] + " mr-8"}></div>
              <div>{this.localizedAnswerOptionsOther[i]}</div>
            </div>
          );
        }
      }
      return (
        <div>
          <div class="headerYesNo">
            <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
              <span class="txtDropdown">
                {this.dateShow}
                {this.renderDropdown()}
              </span>

              <el-dropdown-menu slot="dropdown">
                <div style="max-height: 200px; width: 200px; overflow:auto;">
                  {components}
                </div>
              </el-dropdown-menu>
            </el-dropdown>

            <span class="txtTotalResponse">
              {countMessage} {responses}
            </span>
          </div>
          <div>
            <div class="right flex-reverse fs-12 mt-10">
              {components_answer}
            </div>
          </div>
        </div>
      );
    },
    handleDateCommand(date) {
      if (date) {
        for (const x in this.dateoptions) {
          if (this.dateoptions[x].date === date) {
            this.$store.commit(
              "question/setDateShow",
              this.dateoptions[x]["show"]
            );
          }
        }
      }
      this.$store.commit("question/setLoading", true);
      if (this.dialogYesNo) {
        this.$store.dispatch("question/getDataMultiChoices", {
          date,
          quest_id: this.quest_id,
        });
      } else if (this.dialogMultipleOther) {
        this.$store.dispatch("question/getDataMultiChoicesOther", {
          date,
          quest_id: this.quest_id,
        });
      } else if (this.dialogScale) {
        this.$store.dispatch("question/getDataScale", {
          date,
          quest_id: this.quest_id,
        });
      } else {
        this.$store.dispatch("question/getDataOpenEnd", {
          date,
          quest_id: this.quest_id,
        });
      }
    },
    onInputQuestionEn(text) {
      if (this.engonly) {
        this.dynamicValidateForm.question_th = text;
      }
    },
    retrunTypName(keyDimation) {
      //console.log("keyDimation", keyDimation)
      const dimension = _.filter(this.optionsCategory, {
        key: keyDimation,
      }).map((v) => v.category);
      const imageList = [
        {
          imageName: "email-header-ambassardorship",
          name: "Ambassadorship",
        },
        {
          imageName: "email-header-companyalignment",
          name: "Company Alignment",
        },
        {
          imageName: "email-header-feedback",
          name: "Feedback",
        },
        {
          imageName: "email-header-happiness",
          name: "Happiness",
        },
        {
          imageName: "email-header-introspection",
          name: "Introspection",
        },
        {
          imageName: "email-header-recognition",
          name: "Recognition",
        },
        {
          imageName: "email-header-relationshipwithcolleagues",
          name: "Relationship with Colleagues",
        },
        {
          imageName: "email-header-relationshipmanager",
          name: "Relationship with Manager",
        },
        {
          imageName: "email-header-satisfaction",
          name: "Satisfaction",
        },
        {
          imageName: "email-header-wellness",
          name: "Wellness",
        },
        {
          imageName: "email-header-personalgrowth",
          name: "Personal Growth",
        },
      ];
      const pic = _.filter(imageList, { name: dimension[0] }).map(
        (v) => v.imageName
      );
      const images = require.context(
        "@/assets/images/questions/",
        false,
        /\.png$/
      );
      return images("./" + pic[0] + ".png");
    },
    questionPlaceholder(type, lang) {
      let placeholder = "Question";
      if (type == "Multiple Choice") {
        placeholder = "Question";
      } else if (type == "Multiple Choice(other)") {
        placeholder = "Question";
      } else if (type == "Scale") {
        placeholder = "On a scale of 0 to 10…";
      } else if (type == "Text Area Field") {
        placeholder = "Question";
      }
      return placeholder + " " + lang;
    },
    previewOptionsText(options) {
      let text = "";
      let firstText = true;
      if (options.length > 1) {
        const length = options.length;
        for (let i = 0; i < length; i++) {
          if (options[i].feeling == "Positive") {
            if (firstText) {
              firstText = false;
              text = "" + options[i].en;
            } else {
              text = text + `" or "` + options[i].en;
            }
          }
        }
        text = text + "";
        if (text.length < 3) {
          text = "" + options[0].en + "";
        }
      } else if (options) {
        text = options[0].en;
      }
      if (text.length > 3) {
        return text;
      } else {
        return "Option...";
      }
    },
    async downloadExcel_Open_ended() {
      var date_data = format(this.dateShow, "YYYY-MM-DD");
      var question = this.quest_name
        .trim()
        .split(" ")
        .slice(0, 5)
        .join("_")
        .replace(/[^a-zA-Z0-9_]/g, "");
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Open-ended";
      ws.getCell("B6").value = this.dateShow;

      // Use filtered data for count
      const dataToExport = this.filteredDataOpenEnd.filter(item => !item.Summary);
      let countMessage = dataToExport.length;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      
      // Add team filter info if applied
      let filterInfo = countMessage + " " + responses;
      if (this.selectedTeamFilter !== 'all') {
        const teamInfo = this.selectedTeamInfo;
        filterInfo += ` (filtered by: ${teamInfo ? teamInfo.label : 'Unknown Team'})`;
      }
      
      ws.getCell("B7").value = filterInfo;
      ws.getCell("B8").value = "";
      ws.getColumn("A").width = 5;
      ws.getColumn("B").width = 25; // Team name column
      ws.getColumn("C").width = 80; // Response column
      
      // Add headers
      ws.getCell("B9").value = "Team";
      ws.getCell("C9").value = "Response";
      ws.getCell("B9").font = { bold: true };
      ws.getCell("C9").font = { bold: true };
      
      // Add data with team names
      _.forEach(dataToExport, (item, key) => {
        const teamInfo = this.getTeamNameInfo(item.team);
        let _tmp = ["", teamInfo.name, item.answer || item];
          ws.addRow(_tmp);
      });

      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = "Happily_Open_Ended_" + date_data + "_" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    async downloadExcel_YesorNO() {
     
      var team = [];
      var level0 = [];
      var data = [];
      this.teamAll.map((value) => {
      
        let total = 0;
        let resY = 0;
        let resN = 0;
        let parent_name =
          this.teamArr[value.parent] !== undefined
            ? this.teamArr[value.parent].name
            : "noun";
        if (this.teamArr[value.parent] === undefined) {
         
          level0.push(value);
        }
        if (this.datamultichoices[value.key]) {
          total =
            this.datamultichoices[value.key][0] +
            this.datamultichoices[value.key][1];
          resY = this.datamultichoices[value.key][0];
          resN = this.datamultichoices[value.key][1];
        }
        team.push({
          ...value,
          parent_name: parent_name,
          percentYes: this.getYesPercent(value.key),
          percentNo: this.getNoPercent(value.key),
          resY: resY,
          resN: resN,
          total_res: total,
        });
      });
      if (Object.keys(this.deletedTeam).length > 0) {
        let index = 1;
        for (const keyId in this.deletedTeam) {
          let total = 0;
          let resY = 0;
          let resN = 0;
          let parent_name =
            this.teamArr[this.teamHeight] !== undefined
              ? this.teamArr[this.teamHeight].name
              : "noun";
          if (this.datamultichoices[keyId]) {
            total =
              this.datamultichoices[keyId][0] +
              this.datamultichoices[keyId][1];
            resY = this.datamultichoices[keyId][0];
            resN = this.datamultichoices[keyId][1];
          }
          team.push({
            key: keyId,
            name: 'Deleted Team ' + index,
            parent: this.teamHeight,
            parent_name: parent_name,
            percentYes: this.getYesPercent(keyId),
            percentNo: this.getNoPercent(keyId),
            resY: resY,
            resN: resN,
            total_res: total,
          });
          index++
        }
      }
      const organizations = this.organizations;
      this.organization1level = {};
      const organization1level = this.organization1level;
      
      let teams =''
      if(this.user.user_type == 'leadership'){
         teams = organizations[this.user.team];
      }else{
         teams = organizations[level0[0]?level0[0].key:''];
      }
      if (teams) {
        organization1level[teams.team_id] = true;
        _.forEach(teams.parent, (value) => {
          organization1level[value.team_id] = true;
          if (value.parent) {
            this.getTeamOfParent(value.parent);
            // dispatch('getTeamOfParent', value.parent)
          }
        });
      } else {
        organization1level[level0[0].key] = true;
      }
      if (Object.keys(this.deletedTeam).length > 0) {
        for (const keyId2 in this.deletedTeam) {
          if(this.user.user_type == 'leadership'){
            if(this._organization1level[this.user.team][keyId2]){
              organization1level[keyId2] = true;
            }

          }else{
            organization1level[keyId2] = true;
          }
          
        }
      }
      
      _.forEach(organization1level, (value, team_id) => {
       
        let _temp = _.find(team, ["key", team_id]);
        
        data.push(_temp);
      });
      var date_data = format(this.dateShow, "YYYY-MM-DD");
      var question = this.quest_name
        .trim()
        .split(" ")
        .slice(0, 5)
        .join("_")
        .replace(/[^a-zA-Z0-9_]/g, "");
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Yes/No";
      ws.getCell("B6").value = this.dateShow;

      const countMessage = this.dataopenend.length;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Team Name",
        "Parent Team",
        "Option",
        "Value (%)",
        "Responses",
        "Total Responses",
      ];
      ws.getRow(7).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        if (item) {
          let _tmp = [
            "",
            item.name,
            item.parent_name,
            "Yes",
            item.percentYes,
            item.resY,
            item.total_res,
          ];
          ws.addRow(_tmp);
          let _tmp1 = ["", "", "", "No", item.percentNo, item.resN];
          ws.addRow(_tmp1);
        }
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = "Happily_Yes_No_" + date_data + "_" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    async downloadExcel_Scale() {
      var team = [];
      var level0 = [];
      var data = [];
      this.teamAll.map((value) => {
        let total = 0;
        let avg = {};
        let parent_name =
          this.teamArr[value.parent] !== undefined
            ? this.teamArr[value.parent].name
            : "noun";
        if (this.teamArr[value.parent] === undefined) {
          level0.push(value);
        }
        if (this.datamultichoices[value.key]) {
          for (
            var i = 0;
            i < this.datamultichoices[value.key]["range"].length;
            i++
          ) {
            total += this.datamultichoices[value.key]["range"][i];
          }
          avg = this.datamultichoices[value.key].avg;
        }
        team.push({
          ...value,
          parent_name: parent_name,
          total_res: total,
          avg: avg,
          range0to6: this.getScalePercent(value.key, 0),
          range7to8: this.getScalePercent(value.key, 1),
          range9to10: this.getScalePercent(value.key, 2),
        });
      });
      if (Object.keys(this.deletedTeam).length > 0) {
        let index = 1;
        for (const keyId in this.deletedTeam) {
          let total = 0;
          let avg = {};
          let parent_name =
            this.teamArr[this.teamHeight] !== undefined
              ? this.teamArr[this.teamHeight].name
              : "noun";
          if (this.datamultichoices[keyId]) {
            for (
              var i = 0;
              i < this.datamultichoices[keyId]["range"].length;
              i++
            ) {
              total += this.datamultichoices[keyId]["range"][i];
            }
            avg = this.datamultichoices[keyId].avg;
          }
          team.push({
            key: keyId,
            name: 'Deleted Team ' + index,
            parent: this.teamHeight,
            parent_name: parent_name,
            total_res: total,
            avg: avg,
            range0to6: this.getScalePercent(keyId, 0),
            range7to8: this.getScalePercent(keyId, 1),
            range9to10: this.getScalePercent(keyId, 2),
          });
          index++;
        }
      }
      const organizations = this.organizations;
      this.organization1level = {};
      const organization1level = this.organization1level;
      let teams = '';
      if (this.user.user_type == 'leadership') {
        teams = organizations[this.user.team];
      } else {
        teams = organizations[level0[0] ? level0[0].key : ''];
      }
      if (teams) {
        organization1level[teams.team_id] = true;
        _.forEach(teams.parent, (value) => {
          organization1level[value.team_id] = true;
          if (value.parent) {
            this.getTeamOfParent(value.parent);
          }
        });
      } else if (level0[0]) {
        organization1level[level0[0].key] = true;
      }
      if (Object.keys(this.deletedTeam).length > 0) {
        for (const keyId2 in this.deletedTeam) {
          if (this.user.user_type == 'leadership') {
            if (this._organization1level[this.user.team][keyId2]) {
              organization1level[keyId2] = true;
            }
          } else {
            organization1level[keyId2] = true;
          }
        }
      }
      _.forEach(organization1level, (value, team_id) => {
        let _temp = _.find(team, ["key", team_id]);
        data.push(_temp);
      });
      var date_data = format(this.dateShow, "YYYY-MM-DD");
      var question = this.quest_name
        .trim()
        .split(" ")
        .slice(0, 5)
        .join("_")
        .replace(/[^a-zA-Z0-9_]/g, "");
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Scale";
      ws.getCell("B6").value = this.dateShow;

      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Team Name",
        "Parent Team",
        "Average Rating",
        "0-6 (%)",
        "7-8 (%)",
        "9-10 (%)",
        "Total Responses",
      ];
      ws.getRow(7).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        if (item) {
          let _tmp = [
            "",
            item.name,
            item.parent_name,
            item.avg,
            item.range0to6,
            item.range7to8,
            item.range9to10,
            item.total_res,
          ];
          ws.addRow(_tmp);
        }
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then((xls64) => {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = "Happily_Scale_" + date_data + "_" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    async downloadExcel_MultipleChoice() {
      var team = [];
      var level0 = [];
      var data = [];
      this.teamAll.map((value) => {
        let total = 0;
        let option = {};
        let parent_name =
          this.teamArr[value.parent] !== undefined
            ? this.teamArr[value.parent].name
            : "noun";
        if (this.teamArr[value.parent] === undefined) {
          level0.push(value);
        }
        if (this.datamultichoices[value.key]) {
          for (var i = 0; i < this.datamultichoices[value.key].length; i++) {
            total += this.datamultichoices[value.key][i];
            option[`precent${i + 1}`] = this.getMultipleChoicePercent(value.key, this.answerOpt.length - i - 1);
            option[`res${i + 1}`] = this.datamultichoices[value.key][this.answerOpt.length - i - 1];
            option[`options${i + 1}`] = this.answerOpt[i];
            option['optionCount'] = option['optionCount'] ? option['optionCount'] + 1 : 1;
          }
        }
        team.push({
          ...value,
          parent_name: parent_name,
          total_res: total,
          ...option,
        });
      });
      if (Object.keys(this.deletedTeam).length > 0) {
        let index = 1;
        for (const keyId in this.deletedTeam) {
          let total = 0;
          let option = {};
          let parent_name =
            this.teamArr[this.teamHeight] !== undefined
              ? this.teamArr[this.teamHeight].name
              : "noun";
          if (this.datamultichoices[keyId]) {
            for (var i = 0; i < this.datamultichoices[keyId].length; i++) {
              total += this.datamultichoices[keyId][i];
              option[`precent${i + 1}`] = this.getMultipleChoicePercent(keyId, this.answerOpt.length - i - 1);
              option[`res${i + 1}`] = this.datamultichoices[keyId][this.answerOpt.length - i - 1];
              option[`options${i + 1}`] = this.answerOpt[i];
              option['optionCount'] = option['optionCount'] ? option['optionCount'] + 1 : 1;
            }
          }
          team.push({
            key: keyId,
            name: 'Deleted Team ' + index,
            parent: this.teamHeight,
            parent_name: parent_name,
            total_res: total,
            ...option,
          });
          index++;
        }
      }
      const organizations = this.organizations;
      this.organization1level = {};
      const organization1level = this.organization1level;
      let teams = '';
      if (this.user.user_type == 'leadership') {
        teams = organizations[this.user.team];
      } else {
        teams = organizations[level0[0] ? level0[0].key : ''];
      }
      if (teams) {
        organization1level[teams.team_id] = true;
        _.forEach(teams.parent, (value) => {
          organization1level[value.team_id] = true;
          if (value.parent) {
            this.getTeamOfParent(value.parent);
          }
        });
      } else if (level0[0]) {
        organization1level[level0[0].key] = true;
      }
      if (Object.keys(this.deletedTeam).length > 0) {
        for (const keyId2 in this.deletedTeam) {
          if (this.user.user_type == 'leadership') {
            if (this._organization1level[this.user.team][keyId2]) {
              organization1level[keyId2] = true;
            }
          } else {
            organization1level[keyId2] = true;
          }
        }
      }
      _.forEach(organization1level, (value, team_id) => {
        let _temp = _.find(team, ["key", team_id]);
        data.push(_temp);
      });
      var date_data = format(this.dateShow, "YYYY-MM-DD");
      var question = this.quest_name
        .trim()
        .split(" ")
        .slice(0, 5)
        .join("_")
        .replace(/[^a-zA-Z0-9_]/g, "");
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Multiple Choice";
      ws.getCell("B6").value = this.dateShow;

      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Team Name",
        "Parent Team",
        "Option",
        "Value (%)",
        "Responses",
        "Total Responses",
      ];
      ws.getRow(7).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        if (item && item.optionCount && item.optionCount > 0) {
          for (var i = 1; i <= item.optionCount; i++) {
            if (i === 1) {
              let _tmp = [
                "",
                item.name,
                item.parent_name,
                item[`options${i}`],
                item[`precent${i}`],
                item[`res${i}`],
                item.total_res,
              ];
              ws.addRow(_tmp);
            } else {
              let _tmp = [
                "",
                "",
                "",
                item[`options${i}`],
                item[`precent${i}`],
                item[`res${i}`],
              ];
              ws.addRow(_tmp);
            }
          }
        }
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then((xls64) => {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = "Happily_Multiple_Choice_" + date_data + "_" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    // Team filtering and anonymity methods
    getTeamNameInfo(teamId) {
      // Cache the result to avoid repeated calculations
      if (!this._teamNameCache) {
        this._teamNameCache = {};
      }
      
      if (!this._teamNameCache[teamId]) {
        this._teamNameCache[teamId] = this.getAnonymousTeamName(teamId);
      }
      
      return this._teamNameCache[teamId];
    },
    isTeamViable(teamId) {
      // Check if a team meets privacy thresholds
      const responseCount = this.getAggregatedTeamResponseCount(teamId);
      const memberCount = this.getAggregatedTeamMemberCount(teamId);
      return responseCount >= this.MIN_RESPONSES_FOR_TEAM_NAME && 
             (!this.USE_MEMBER_COUNT_CHECK || memberCount >= this.MIN_MEMBERS_FOR_TEAM_NAME);
    },
    getTeamResponseCount(teamId) {
      // Count responses for this team in current dataset
      if (!this.dataopenend || !Array.isArray(this.dataopenend)) return 0;
      
      return this.dataopenend.filter(item => 
        item.team === teamId && !item.Summary
      ).length;
    },
    getTeamMemberCount(teamId) {
      // Get member count from allUsers data
      if (!this.allUsers || !Array.isArray(this.allUsers)) {
        return 0;
      }
      
      // Try different status field names
      return this.allUsers.filter(user => 
        user.team === teamId && (user.status === 'active' || user.status === 'Y' || !user.status)
      ).length;
    },
    getAllDescendantTeams(teamId, descendants = [], visited = new Set()) {
      // Prevent infinite recursion by tracking visited teams
      if (visited.has(teamId)) {
        console.warn(`Circular reference detected for team ${teamId}`);
        return descendants;
      }
      
      visited.add(teamId);
      
      // Recursively get all child teams
      for (const [childId, childTeam] of Object.entries(this.teamArr)) {
        if (childTeam && childTeam.parent === teamId && !visited.has(childId)) {
          descendants.push(childId);
          this.getAllDescendantTeams(childId, descendants, visited);
        }
      }
      return descendants;
    },
    getAggregatedTeamResponseCount(teamId) {
      // Get response count including all child teams
      const allTeams = [teamId, ...this.getAllDescendantTeams(teamId)];
      
      if (!this.dataopenend || !Array.isArray(this.dataopenend)) return 0;
      
      return this.dataopenend.filter(item => 
        allTeams.includes(item.team) && !item.Summary
      ).length;
    },
    getAggregatedTeamMemberCount(teamId) {
      // Get member count including all child teams
      const allTeams = [teamId, ...this.getAllDescendantTeams(teamId)];
      
      if (!this.allUsers || !Array.isArray(this.allUsers)) return 0;
      
      return this.allUsers.filter(user => 
        allTeams.includes(user.team) && user.status === 'active'
      ).length;
    },
    handleTeamFilterChange(teamId) {
      this.selectedTeamFilter = teamId;
    },
    getSelectedTeamInfo() {
      if (this.selectedTeamFilter === 'all') {
        return null;
      }
      
      const selectedOption = this.availableTeamOptions.find(option => option.value === this.selectedTeamFilter);
      return selectedOption;
    },
    getTeamDepth(teamId, depth = 0, visited = new Set()) {
      // Prevent infinite recursion by tracking visited teams
      if (visited.has(teamId)) {
        console.warn(`Circular reference detected in getTeamDepth for team ${teamId}`);
        return depth;
      }
      
      visited.add(teamId);
      
      const team = this.teamArr[teamId];
      if (!team || !team.parent || !this.teamArr[team.parent]) {
        return depth;
      }
      return this.getTeamDepth(team.parent, depth + 1, visited);
    },
    getTeamColorClass(teamId) {
      if (!teamId) return 'team-color-default';
      
      // Special handling for organization fallback
      if (teamId === 'organization') {
        return 'team-color-default';
      }
      
      // Get the first-level child of the root parent for consistent branch coloring
      const branchParent = this.getBranchParentTeam(teamId);
      
      // Create a deterministic color based on branch parent ID
      const colorClasses = [
        'team-color-0', // Blue
        'team-color-1', // Purple
        'team-color-2', // Green  
        'team-color-3', // Orange
        'team-color-4'  // Pink
      ];
      
      // Use a simple hash of the branch parent ID to determine color
      let hash = 0;
      for (let i = 0; i < branchParent.length; i++) {
        hash = ((hash << 5) - hash) + branchParent.charCodeAt(i);
        hash = hash & hash; // Convert to 32bit integer
      }
      
      const colorIndex = Math.abs(hash) % colorClasses.length;
      return colorClasses[colorIndex];
    },
    getBranchParentTeam(teamId) {
      // Find the direct child of the root parent (the branch this team belongs to)
      const rootParent = this.getRootParentTeam(teamId);
      
      // If this team IS the root parent, use its ID
      if (teamId === rootParent) {
        return rootParent;
      }
      
      // Walk up the hierarchy to find the direct child of root parent
      let currentTeamId = teamId;
      let branchParent = teamId;
      
      while (currentTeamId) {
        const team = this.teamArr[currentTeamId];
        if (!team || !team.parent) break;
        
        // If the parent is the root parent, then current team is the branch parent
        if (team.parent === rootParent) {
          branchParent = currentTeamId;
          break;
        }
        
        // If the parent doesn't exist in teamArr, this might be the branch parent
        if (!this.teamArr[team.parent]) {
          branchParent = currentTeamId;
          break;
        }
        
        currentTeamId = team.parent;
      }
      
      return branchParent;
    },
    getRootParentTeam(teamId) {
      // Find the topmost parent team
      let currentTeamId = teamId;
      let rootTeam = teamId;
      const visited = new Set();
      
      while (currentTeamId) {
        // Prevent infinite loop
        if (visited.has(currentTeamId)) {
          console.warn(`Circular reference detected in getRootParentTeam for team ${currentTeamId}`);
          break;
        }
        visited.add(currentTeamId);
        
        const team = this.teamArr[currentTeamId];
        if (!team || !team.parent || !this.teamArr[team.parent]) {
          rootTeam = currentTeamId;
          break;
        }
        currentTeamId = team.parent;
      }
      
      return rootTeam;
    },
    findViableParentTeam(teamId) {
      // Find the closest parent team (including self) that meets privacy thresholds
      let currentTeamId = teamId;
      const visited = new Set();
      
      while (currentTeamId) {
        // Prevent infinite loop
        if (visited.has(currentTeamId)) {
          console.warn(`Circular reference detected in findViableParentTeam for team ${currentTeamId}`);
          break;
        }
        visited.add(currentTeamId);
        
        const team = this.teamArr[currentTeamId];
        if (!team) break;
        
        const responseCount = this.getAggregatedTeamResponseCount(currentTeamId);
        const memberCount = this.getAggregatedTeamMemberCount(currentTeamId);
        const meetsThreshold = responseCount >= this.MIN_RESPONSES_FOR_TEAM_NAME && 
                             (!this.USE_MEMBER_COUNT_CHECK || memberCount >= this.MIN_MEMBERS_FOR_TEAM_NAME);
        
        if (meetsThreshold) {
          return {
            teamId: currentTeamId,
            label: team.name || team.team_name || 'Team',
            responseCount,
            memberCount,
            depth: this.getTeamDepth(currentTeamId)
          };
        }
        
        // Move up to parent
        currentTeamId = team.parent;
      }
      
      // If no viable parent found, return Organization level
      return {
        teamId: 'organization',
        label: 'Organization',
        responseCount: this.getTeamResponseCount(teamId),
        memberCount: 0,
        depth: 0
      };
    },
    getAnonymousTeamName(teamId, responseCount = 1, isCheckingParent = false) {
      // Use configurable thresholds
      const MIN_RESPONSES = this.MIN_RESPONSES_FOR_TEAM_NAME;
      const MIN_MEMBERS = this.MIN_MEMBERS_FOR_TEAM_NAME;
      
      if (!teamId) {
        return { name: 'Organization', isCascaded: false, teamId: 'organization' };
      }
      
      const team = this.teamArr[teamId];
      if (!team) {
        // If team not found in teamArr, check if it's a deleted team
        if (this.deletedTeam && this.deletedTeam[teamId]) {
          return { name: 'Organization', isCascaded: false, teamId: 'organization' };
        }
        return { name: 'Organization', isCascaded: false, teamId: 'organization' };
      }
      
      // Check if this team is viable (same logic as dropdown)
      if (this.isTeamViable(teamId)) {
        return { name: team.name || team.team_name || 'Team', isCascaded: false, teamId: teamId };
      }
      
      // If not viable, find the viable parent
      const viableParent = this.findViableParentTeam(teamId);
      if (viableParent && viableParent.teamId !== 'organization') {
        const parentTeam = this.teamArr[viableParent.teamId];
        if (parentTeam) {
          return { name: parentTeam.name || parentTeam.team_name || 'Team', isCascaded: true, teamId: viableParent.teamId };
        }
      }
      
      // If no viable parent found, return generic label with consistent ID
      return { name: 'Organization', isCascaded: false, teamId: 'organization' };
    },
    handleSortChange({ prop, order }) {
      if (!prop || !this.questions) return;

      const sortedQuestions = [...this.questions].sort((a, b) => {
        let dateA = this.getNextOccurrence(a);
        let dateB = this.getNextOccurrence(b);

        // Remove parentheses if present
        dateA = dateA ? dateA.replace(/[()]/g, '') : dateA;
        dateB = dateB ? dateB.replace(/[()]/g, '') : dateB;

        // Helper function to check if a value is a valid date
        const isValidDate = (value) => {
          if (!value) return false;
          if (value === 'One-time' || value === 'Follow-up' || value === '-') return false;
          const date = new Date(value);
          return date instanceof Date && !isNaN(date);
        };

        // If both are dates
        if (isValidDate(dateA) && isValidDate(dateB)) {
          const comparison = new Date(dateA) - new Date(dateB);
          return order === 'ascending' ? comparison : -comparison;
        }

        // If only one is a date
        if (isValidDate(dateA)) return order === 'ascending' ? -1 : 1;
        if (isValidDate(dateB)) return order === 'ascending' ? 1 : -1;

        // Neither is a date, handle special values
        const specialValues = {
          'Follow-up': 1,
          'One-time': 2,
          '-': 3
        };

        const valueA = specialValues[dateA] || 3;
        const valueB = specialValues[dateB] || 3;

        const comparison = valueA - valueB;
        return order === 'ascending' ? comparison : -comparison;
      });

      this.$store.commit('custom/setQuestions', sortedQuestions);
    },
    getNextOccurrence(row) {
      // For follow-up questions
      if (row.parent !== 'N') {
        return 'Follow-up';
      }

      // For one-time questions
      if (!row.repeats || row.repeats === 'onetime') {
        if (!row.delivery_date && !row.starton) return 'One-time';
        const deliveryDate = row.delivery_date ? new Date(row.delivery_date) : 
                           row.starton ? new Date(row.starton.split('/').reverse().join('-')) : null;
        if (!deliveryDate) return 'One-time';
        const today = new Date();
        return deliveryDate < today ? 
          `(${deliveryDate.toLocaleDateString('default', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          })})` : 
          deliveryDate.toLocaleDateString('default', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          });
      }

      // For weekly questions
      if (row.repeats === 'weekly' && row.repeat_days) {
        const today = new Date();
        const currentDay = today.getDay(); // 0-6 (Sunday-Saturday)
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        
        // Get only the days that are enabled ('Y')
        const enabledDays = days
          .map((day, index) => ({ day, index }))
          .filter(({ day }) => row.repeat_days[day] === 'Y')
          .map(({ index }) => index);

        if (enabledDays.length === 0) {
          return 'No schedule';
        }

        // Find the next enabled day
        let nextDay = enabledDays.find(day => day > currentDay);
        if (nextDay === undefined) {
          // If no days left this week, get the first enabled day of next week
          nextDay = enabledDays[0];
        }

        // Calculate the date
        const nextDate = new Date(today);
        const daysToAdd = nextDay > currentDay ? 
          nextDay - currentDay : 
          7 - currentDay + nextDay;
        
        nextDate.setDate(today.getDate() + daysToAdd);

        return nextDate.toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      // For daily questions
      if (row.repeats === 'daily') {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      const today = new Date();
      const currentWeek = Math.ceil(today.getDate() / 7);
      const currentDay = today.toLocaleDateString('en-US', { weekday: 'short' });
      const currentQuarter = Math.floor((today.getMonth() / 3)) + 1;
      const currentMonth = today.getMonth();

      // Get next scheduled day
      let nextDay = null;
      if (row.repeat_days) {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const currentDayIndex = days.indexOf(currentDay);
        const nextDayIndex = days.findIndex((day, index) =>
          index > currentDayIndex && row.repeat_days[day] === 'Y'
        ) || days.findIndex(day => row.repeat_days[day] === 'Y');

        if (nextDayIndex >= 0) {
          nextDay = days[nextDayIndex];
        }
      }

      // Get next scheduled week
      let nextWeek = null;
      if (row.repeat_weeks) {
        const weeks = ['week1', 'week2', 'week3', 'week4', 'week5'];
        const nextWeekIndex = weeks.findIndex((week, index) =>
          index + 1 >= currentWeek && row.repeat_weeks[week] === 'Y'
        ) || weeks.findIndex(week => row.repeat_weeks[week] === 'Y');

        if (nextWeekIndex >= 0) {
          nextWeek = nextWeekIndex + 1;
        }
      }

      // Get next scheduled quarter
      let nextQuarter = null;
      if (row.repeat_quarters) {
        const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
        const nextQuarterIndex = quarters.findIndex((q, index) =>
          index + 1 >= currentQuarter && row.repeat_quarters[q] === 'Y'
        ) || quarters.findIndex(q => row.repeat_quarters[q] === 'Y');

        if (nextQuarterIndex >= 0) {
          nextQuarter = nextQuarterIndex + 1;
        }
      }

      // Format the next occurrence message based on repeat type
      switch (row.repeats) {
        case 'biannually':
        case 'quarterly':
          if (nextQuarter) {
            const today = new Date();
            const currentMonth = today.getMonth();
            const currentQuarter = Math.floor(currentMonth / 3) + 1;

            // Get available quarters
            const availableQuarters = Object.entries(row.repeat_quarters)
              .filter(([_, value]) => value === 'Y')
              .map(([quarter]) => parseInt(quarter.substring(1)));

            // Calculate dates for all available quarters in current year
            const possibleDates = availableQuarters.map(quarter => {
              // Always start with current year
              const year = today.getFullYear();
              const quarterStartMonth = (quarter - 1) * 3;
              const targetMonth = quarterStartMonth + (parseInt(row.repeat_quarter) - 1);

              const date = new Date(year, targetMonth, 1);

              // If we have specific week and day settings, use those
              if (row.repeat_weeks && row.repeat_days) {
                const weekEntry = Object.entries(row.repeat_weeks)
                  .find(([_, value]) => value === 'Y');
                const targetWeek = weekEntry ? weekEntry[0] : null;

                const dayEntry = Object.entries(row.repeat_days)
                  .find(([_, value]) => value === 'Y');
                const targetDay = dayEntry ? dayEntry[0] : null;

                if (targetWeek && targetDay) {
                  const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
                  const targetDayNum = dayMap[targetDay];

                  if (targetDayNum !== undefined) {
                    // Calculate days to add to reach target day
                    let daysToAdd = (targetDayNum - date.getDay() + 7) % 7;
                    date.setDate(date.getDate() + daysToAdd);

                    // Add weeks to get to target week
                    const weekNumber = parseInt(targetWeek.replace('week', ''));
                    date.setDate(date.getDate() + (weekNumber - 1) * 7);
                  }
                }
              }

              // If this date is in the past, add a year
              if (date < today) {
                date.setFullYear(year + 1);
              }

              return date;
            });

            // Find the next occurrence (first date that's in the future)
            const nextDate = possibleDates.sort((a, b) => a - b).find(date => date > today);

            if (nextDate) {
              return nextDate.toLocaleDateString('default', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
              });
            }
          }
          break;

        case 'semi-annually':
          if (row.repeat_quarters) {
            const activeQuarters = Object.entries(row.repeat_quarters)
              .filter(([_, value]) => value === 'Y')
              .map(([quarter]) => parseInt(quarter.substring(1)));

            const nextHalfYear = activeQuarters.find(q => q > currentQuarter) || activeQuarters[0];
            const quarterStartMonths = [0, 3, 6, 9]; // Jan, Apr, Jul, Oct
            const nextYear = today.getFullYear() + (nextHalfYear <= currentQuarter ? 1 : 0);
            const nextDate = new Date(nextYear, quarterStartMonths[nextHalfYear - 1], 1);
            return nextDate.toLocaleDateString('default', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            });
          }
          break;

        case 'weekly':
          if (nextDay) {
            const daysToAdd = (7 + ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(nextDay) - today.getDay()) % 7;
            const nextDate = new Date(today);
            nextDate.setDate(today.getDate() + daysToAdd);
            return nextDate.toLocaleDateString();
          }
          break;

        case 'monthly':
          if (row.repeat_weeks && row.repeat_days) {
            const today = new Date();
            
            // Get the target week and day
            const weekEntry = Object.entries(row.repeat_weeks)
              .find(([_, value]) => value === 'Y');
            const targetWeek = weekEntry ? weekEntry[0] : null;
            
            const dayEntry = Object.entries(row.repeat_days)
              .find(([_, value]) => value === 'Y');
            const targetDay = dayEntry ? dayEntry[0] : null;

            if (targetWeek && targetDay) {
              // Convert day name to day number (0-6)
              const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
              const targetDayNum = dayMap[targetDay];

              if (targetDayNum !== undefined) {
                // Start with the first day of current/next month
                const nextDate = new Date(today.getFullYear(), 
                  today.getMonth() + (nextWeek < currentWeek ? 1 : 0), 
                  1);

                // Calculate days to add to reach target day
                let daysToAdd = (targetDayNum - nextDate.getDay() + 7) % 7;
                nextDate.setDate(nextDate.getDate() + daysToAdd);

                // Add weeks to get to target week
                const weekNumber = parseInt(targetWeek.replace('week', ''));
                nextDate.setDate(nextDate.getDate() + (weekNumber - 1) * 7);

                // If the calculated date is in the past, move to next month
                if (nextDate < today) {
                  nextDate.setMonth(nextDate.getMonth() + 1);
                }

                return nextDate.toLocaleDateString('default', {
                  month: 'short',
                  day: 'numeric', 
                  year: 'numeric'
                });
              }
            }
          }
          break;

        case 'bi-monthly':
          if (nextWeek && nextDay) {
            // Calculate next bi-monthly occurrence
            let monthsToAdd = 2 - (currentMonth % 2);
            if (nextWeek < currentWeek) monthsToAdd += 2;
            const nextDate = new Date(today.getFullYear(), today.getMonth() + monthsToAdd);
            return `Week ${nextWeek}, ${nextDate.toLocaleString('default', { month: 'short' })} ${nextDate.getFullYear()}`;
          }
          break;

        case 'yearly':
          if (row.repeat_months && row.repeat_weeks && row.repeat_days) {
            const targetMonth = row.repeat_months;

            // Convert month name to month number (0-11)
            const monthMap = {
              January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
              July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
            };
            const targetMonthNum = monthMap[targetMonth];

            // Get the target week and day
            const weekEntry = Object.entries(row.repeat_weeks)
              .find(([_, value]) => value === 'Y');
            const targetWeek = weekEntry ? weekEntry[0] : null;

            const dayEntry = Object.entries(row.repeat_days)
              .find(([_, value]) => value === 'Y');
            const targetDay = dayEntry ? dayEntry[0] : null;

            if (targetMonthNum !== undefined && targetWeek && targetDay) {
              // Convert day name to day number (0-6)
              const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
              const targetDayNum = dayMap[targetDay];

              if (targetDayNum !== undefined) {
                // Use current year for initial calculation
                const nextDate = new Date(today.getFullYear(), targetMonthNum, 1);

                // Calculate days to add to reach target day
                let daysToAdd = (targetDayNum - nextDate.getDay() + 7) % 7;
                nextDate.setDate(nextDate.getDate() + daysToAdd);

                // Add weeks to get to target week
                const weekNumber = parseInt(targetWeek.replace('week', ''));
                nextDate.setDate(nextDate.getDate() + (weekNumber - 1) * 7);

                // If the calculated date is in the past, move to next year
                if (nextDate < today) {
                  nextDate.setFullYear(today.getFullYear() + 1);
                }

                return nextDate.toLocaleDateString('default', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                });
              }
            }
          }
          break;
      }

      return null;
    },
    isTeamViable(teamId) {
      // Check if a team meets privacy thresholds
      const responseCount = this.getAggregatedTeamResponseCount(teamId);
      const memberCount = this.getAggregatedTeamMemberCount(teamId);
      return responseCount >= this.MIN_RESPONSES_FOR_TEAM_NAME && 
             (!this.USE_MEMBER_COUNT_CHECK || memberCount >= this.MIN_MEMBERS_FOR_TEAM_NAME);
    },
    getTeamResponseCount(teamId) {
      // Count responses for this team in current dataset
      if (!this.dataopenend || !Array.isArray(this.dataopenend)) return 0;
      
      return this.dataopenend.filter(item => 
        item.team === teamId && !item.Summary
      ).length;
    },
    getTeamMemberCount(teamId) {
      // Get member count from allUsers data
      if (!this.allUsers || !Array.isArray(this.allUsers)) {
        return 0;
      }
      
      // Try different status field names
      return this.allUsers.filter(user => 
        user.team === teamId && (user.status === 'active' || user.status === 'Y' || !user.status)
      ).length;
    },
    handleSelectAllQuestionType() {
      if (this.checkedQuestionType.length !== this.questionTypeOption.length) {
        let checked = [];
        for (const i in this.questionTypeOption) {
          checked.push(this.questionTypeOption[i].type);
        }
        this.checkedQuestionType = checked;
      }
    },
    clearQuestionTypeSelected() {
      this.checkedQuestionType = this.questionFilterList;
      this.$refs.dropdownValuesMenu.visible = false;
    },
    saveQuestionTypeFiltered() {
      this.questionFilterList = this.checkedQuestionType;
      this.$refs.dropdownValuesMenu.visible = false;
      this.$store.dispatch("custom/filtersQuestion", { 
        questionstype: this.checkedQuestionType, 
        powerskill: this.checkedArrPowerSkillCheck, 
        dimension: this.checkedDimension 
      });
    },
    handleSelectAllDimension() {
      if (this.checkedDimension.length !== this.dimensionOption.length) {
        let checked = [];
        for (const i in this.dimensionOption) {
          checked.push(this.dimensionOption[i].type);
        }
        this.checkedDimension = checked;
      }
    },
    clearDimensionSelected() {
      this.checkedDimension = this.dimensionFilterList;
      this.$refs.dropdownDimension.visible = false;
    },
    saveDimensionFiltered() {
      this.dimensionFilterList = this.checkedDimension;
      this.$refs.dropdownDimension.visible = false;
      this.$store.dispatch("custom/filtersQuestion", { 
        questionstype: this.checkedQuestionType, 
        powerskill: this.checkedArrPowerSkillCheck, 
        dimension: this.checkedDimension 
      });
    },
    handleSelectAllPowerSkill() {
      if (this.checkedArrPowerSkillCheck.length !== this.powerSkillOption.length) {
        let checked = [];
        for (const i in this.powerSkillOption) {
          checked.push(this.powerSkillOption[i].type);
        }
        this.checkedArrPowerSkillCheck = checked;
      }
    },
    clearPowerSkillSelected() {
      this.checkedArrPowerSkillCheck = this.arrPowerSkillCheck;
      this.$refs.dropdownPowerSkillMenu.visible = false;
    },
    savePowerSkillFiltered() {
      this.arrPowerSkillCheck = this.checkedArrPowerSkillCheck;
      this.$refs.dropdownPowerSkillMenu.visible = false;
      this.$store.dispatch("custom/filtersQuestion", { 
        questionstype: this.checkedQuestionType, 
        powerskill: this.checkedArrPowerSkillCheck, 
        dimension: this.checkedDimension 
      });
    },
    getfollow_up_question(index, options) {
      let label='option '+(index+1)
      if(options){
        if(options.value){
          label=options.value
        }else if(options.en){
          label=options.en
        }
        if(options.question_id){
          this.selectquestionFollewUp = options.question_id
        }
      }else{
        this.selectquestionFollewUp = '';
      }
      this.titleName=`If person responds "{${label}}" then follow up with this question:`
      // Open the follow-up question dialog
      this.follow_up_question = true;
      this.indexOption=index
      
      // Get available follow-up questions from store or set default
      const follow_up =_.filter(this.questioncustomAll,(o)=>{return o.frequency == 'Follow-up';})
      this.questionFollewUp = follow_up || [];
    },
    addFollowUpQuestion() {
      if(this.dynamicValidateForm.type == 'Multiple Choice'){
        
        this.dynamicValidateForm.options_en[this.indexOption].question_id=this.selectquestionFollewUp
        this.dynamicValidateForm.options_th[this.indexOption].question_id=this.selectquestionFollewUp  
      }else {
        this.dynamicValidateForm.options[this.indexOption].question_id=this.selectquestionFollewUp
      }
      // Close the dialog
      this.follow_up_question = false;
      this.selectquestionFollewUp = '';
    },
    // Font detection and styling methods
    getQuestionFontClass(text) {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      // Language-based font selection
      if (selectedLanguage === 'th') {
        return 'font-kanit';
      }
      if (selectedLanguage === 'zh-HK') {
        return 'font-chinese';
      }
      
      // Character-based detection as fallback
      if (text && text.match(/[ก-๙]/)) {
        return 'font-kanit';
      }
      if (text && text.match(/[\u4e00-\u9fff\u3400-\u4dbf]/)) {
        return 'font-chinese';
      }
      
      return 'font-lato';
    },
    
    getQuestionFontStyle(text) {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      // Language-based font selection
      if (selectedLanguage === 'th') {
        return "font-family: 'Kanit', sans-serif";
      }
      if (selectedLanguage === 'zh-HK') {
        return "font-family: 'Noto Sans TC', sans-serif";
      }
      
      // Character-based detection as fallback
      if (text && text.match(/[ก-๙]/)) {
        return "font-family: 'Kanit', sans-serif";
      }
      if (text && text.match(/[\u4e00-\u9fff\u3400-\u4dbf]/)) {
        return "font-family: 'Noto Sans TC', sans-serif";
      }
      
      return "font-family: 'Lato', sans-serif";
    },
    getTotalResponses(id) {
  
        if (!this.datamultichoices[id]) return 0;

        // For Scale type (has 'range' property)
        if (this.datamultichoices[id].range) {
          return this.datamultichoices[id].range.reduce((sum, current) => sum + current, 0);
        }
        
        // For Yes/No type (array with 2 values)
        if (Array.isArray(this.datamultichoices[id]) && this.datamultichoices[id].length === 2) {
          return this.datamultichoices[id][0] + this.datamultichoices[id][1];
        }
        
        // For Multiple Choice (array with multiple values)
        if (Array.isArray(this.datamultichoices[id])) {
          return this.datamultichoices[id].reduce((sum, current) => sum + current, 0);
        }

        return 0;
      },

  },
};
</script>
<style lang="scss" scoped>
.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
  margin-top: 0px;
  margin-right: 48px;
}
.txtQuestion {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 700;
  word-break: normal;
}
.txtType {
  color: #9d9d9d;
  font-size: 16px;
}
.button {
  width: 95px;
}
.txtHeaderModal {
  font-size: 20px;
  color: #2f2f2f;
  font-weight: 800;
}
.summaryLayout {
  background: #6C30CC08 0% 0% no-repeat padding-box;
  border: 1px solid #6C30CC;
  border-radius: 7px;
  opacity: 1;
}

.styleMoreOption {
  cursor: pointer;
  display: flex;
  justify-content: center;
  color: #4a4a4a;
  font-size: 18px;
  font-weight: 800;
  padding-top: 5px;
  padding-bottom: 3px;
}
.btnActionView {
  font-size: 15px;
}
.btnDisableView {
  font-size: 15px;
  background: #f4f4f5;
  opacity: 0.4;
}
.titileDialog {
  font-weight: 700;
  font-size: 20px;
  color: #000000;
}
.txtQuestion {
  font-weight: 700;
  font-size: 18px;
  color: #000000;
}
.txtResponse {
  font-weight: 700;
  font-size: 15px;
  color: #505050;
  margin: 0 24px;
  word-wrap: normal;
  word-break: normal;
}
.txtAllSummary {
  font-weight: 700;
  font-size: 15px;
  color: #505050;
  word-wrap: normal;
  word-break: normal;
}
.txtRepeats {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) 13px/16px var(--unnamed-font-family-lato);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal normal 13px/16px Lato;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.6;
}
.divAllSummary {
  margin: 0 24px;
}
.txtHeaderStrategic {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-15)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-lato);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal bold 15px/18px Lato;
  letter-spacing: 0px;
  color: #000000;
  // margin: 0 0 0 24px;
}
.txtHeaderSummary {
  margin: 0 24px;
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-15)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-lato);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  font: normal normal bold 15px/18px Lato;
  letter-spacing: 0px;
  color: #6C30CC;
  opacity: 1;
}

.txtTotalResponse {
  font-weight: 700;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.3);
  margin-right: 20px;
}
.txtDropdown {
  font-weight: 700;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}
.shadowBottom {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 10px 6px -6px;
  height: 16px;
  background: #fff;
  margin-left: -20px;
  margin-right: -20px;
}
.txtTeam {
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  color: #505050;
  width: 170px;
}
/* Group CSS together so that if we want to change font size for this label type, we only have to do it once.
If they have different attributes (eg. color) we can create that attribute seperately. */
.txtYes,
.txtNo {
  font-weight: 700;
  font-size: 15px;
  color: #66bb6a;
}
.txtNo {
  color: #f44336;
}
.progressYes {
  height: 18px;
  background: #66bb6a;
  margin-left: 4px;
  border-radius: 3px;
}
.progressNo {
  height: 18px;
  background: #f44336;
  margin-left: 4px;
  border-radius: 3px;
}
.empty-table {
  width: 100%;
  height: 320px;
  text-align: center;
  line-height: 320px;
}
.rowItem {
  height: 50px;
  width: 260px;
  background: #f7f7f7;
  align-items: center;
  display: flex;
}
.headerYesNo {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 2px;
}
.headerOpenEnded {
  display: flex;
  justify-content: space-between;
}
div.el-table__body-wrapper.is-scrolling-none {
  height: 520px;
}
.btnAddOption {
  color: #fff;
  background-color: #6c30cc;
  border-color: #6c30cc;
}
.icon-export {
  // padding-right: 8px;
  color: #000;
  margin-right: 10px;
}

.grid-2-section {
  display: grid;
  grid-template-columns: 402px auto;
}
.grid-left {
  background-color: #11223d;
  min-height: 750px;
  .header {
    background-color: #6c30cc;
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    padding: 18px 24px;
  }
  .body {
    padding-top: 47px;
    .image-type {
      width: 52px;
      height: 52px;
      border-radius: 52px;
    }
    .question-card {
      margin-top: 50px;
      min-height: 240px;
      width: 200px;
      background-color: #fff;
      border-radius: 12px;
      > .card-header {
        min-height: 76px;
        background-color: #27bc6c;
        border-radius: 12px 12px 0 0;
      }
    }
  }
}
.grid-right {
  background-color: #f8f8f8;
  padding: 32px;
  .el-form-item__label {
    font-weight: 700;
  }
}
.title-input-form {
  font-weight: 700;
}
.btn-cancel {
  text-transform: capitalize;
  background-color: #747474;
  color: #ffffff;
}
.btn-delete {
  margin-left: 10px;
  text-transform: capitalize;
  background: #f44336;
  color: #ffffff;
  transition: 0.3s;
  &:hover {
    background: #e03d31;
  }
}
.question-send-to {
  border-radius: 3px;
  font-weight: 900;
  font-size: 11px;
  padding: 3px 6px 2px;
  background-color: #7623d4;
  margin-right: 3px;
  color: #fff;
}
.recipients-count {
  font-weight: 700;
  color: #6c30cc;
  font-size: 12px;
  height: 0px;
  text-align: right;
  position: relative;
  .top-header {
    position: absolute;
    bottom: -20px;
    right: 0;
    text-decoration: underline;
  }
}
.imgProfile {
  width: 42px;
  height: 42px;
  background: #dbdbdb;
  border-radius: 21px;
  object-fit: cover;
}
.RecipientsModalStyle {
  box-shadow: 0px 6px 6px #00000014;
}
.divMembersRecipients {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 0 24px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 55vh;
}
.columnDataStyle {
  padding: 0px 24px;
}
.rowDataStyle {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-top: 8px;
  padding-bottom: 8px;
  padding: 8px 40px;
  transition: 0.3s;
  &:hover {
    background: #f5f5f5;
  }
}
.divProfile {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.dropdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-left: 24px;
  padding-right: 16px;
  margin-bottom: 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.dropdownHeaderTextStyle {
  font-size: 13px;
  font-weight: 700;
}

.el-button--text.dropdownHeaderTextStyle {
  color: #32c2d5;
}

.el-button--text.dropdownHeaderTextStyle:hover {
  color: #249fb0;
}

.el-button--text.dropdownHeaderTextStyle:active {
  color: #32c2d5;
}

.tooltipStyle {
  max-width: 240px;
}

.dropdownFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  padding-right: 16px;
  background: #f8f8f8;
  border-top: 1px solid #e8e8e8;

  .el-button--cancel {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
  }

  .el-button--cancel:hover,
  .el-button--cancel:focus {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 0.7;
  }

  .el-button--cancel:active {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 1;
  }

  .el-button--save {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
  }

  .el-button--save:hover,
  .el-button--save:focus {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 0.7;
  }

  .el-button--save:active {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 1;
  }
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: auto;
  min-height: 32px;
  line-height: 1.4;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}

.drop-down-container {
  margin-left: 12px;
  height: 40px;
  border-radius: 4px;
  padding: 0 8px 0 12px;
  min-width: 90px;
}
.drop-down-container.active {
  margin-left: 10px;
  background-color: rgba(#32c2d5, 0.1);
  padding: 0 6px 0 10px;
}

.text-drop-down {
  color: #00acc1;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.drop-down-close {
  position: absolute;
  top: -12px;
  transform: rotate(45deg);
  width: 24px;
  height: 24px;
  margin-left: 4px;

  .x-btn {
    position: relative;
    width: 24px;
    height: 24px;
    cursor: pointer;

    &:before,
    &:after {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      content: "";
      background-color: #747474;
      transition: 0.3s;
    }

    &:before {
      width: 2px;
      height: 20px;
    }

    &:after {
      width: 20px;
      height: 2px;
    }

    &:hover {
      &:before,
      &:after {
        background-color: #333;
      }
    }
  }
}
.div.el-select.input-style {
  width: 500px !important;
}
.talkingPointsBox {
  height: 40px;
}
.talking-points {
  border-width: 0;
  border-radius: 16px;
  font-weight: 700;
  // box-shadow: 0px 2px 4px #00000029;
  transition: 0.2s;
  margin: 8px 8px 0 0;

  &:hover {
    margin-top: 5px;
    // box-shadow: 0px 5px 6px #00000019;
    margin-bottom: 3px;
  }
}
.tooltipStyleTalkingPoints {
  width: 375px;
  padding: 8px;
}
.tooltip-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.tooltip-item {
  display: flex;
  align-items: flex-start;
  padding-top : 11px;
}

.tooltip-item p {
  margin: 0;
  font-size: 12px;
}
.oi-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  background-color: rgba(108, 48, 204, 0.2); /* สีพื้นหลัง */
  // opacity: 0.2;
  color: #6C30CC; /* สีตัวอักษร */
  font-weight: bold;
  margin-right: 12px;
}
.GreenBoxStyle {
  color: #249d2a;
  background-color: #edffee;
}

.RedBoxStyle {
  color: #f44336;
  background-color: #ffedeb;
}

.GreyBoxStyle {
  color: #484848;
  // border-color: #b2b2b2;
  background-color: #f0f0f0;
}

.feedback-team-label {
  align-self: flex-start;
  margin: 0 24px 8px 24px;
  padding: 4px 12px;
  background-color: #f0f0f0;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #626262;
  display: inline-block;
  
  // Color coding for different team hierarchy levels
  &.team-color-0 {
    background-color: #e3f2fd;
    color: #1976d2;
    border: 1px solid #bbdefb;
  }
  
  &.team-color-1 {
    background-color: #f3e5f5;
    color: #7b1fa2;
    border: 1px solid #ce93d8;
  }
  
  &.team-color-2 {
    background-color: #e8f5e8;
    color: #388e3c;
    border: 1px solid #a5d6a7;
  }
  
  &.team-color-3 {
    background-color: #fff3e0;
    color: #f57c00;
    border: 1px solid #ffcc02;
  }
  
  &.team-color-4 {
    background-color: #fce4ec;
    color: #c2185b;
    border: 1px solid #f8bbd9;
  }
  
  &.team-color-default {
    background-color: #f5f5f5;
    color: #616161;
    border: 1px solid #e0e0e0;
  }
}

/* Team Filter Dropdown Styles */
.team-dropdown-header {
  padding: 12px 16px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
  font-size: 13px;
  font-weight: 700;
  color: #626262;
}

.team-search-container {
  padding: 8px 12px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fff;
}

.team-dropdown-content {
  max-height: 280px;
  overflow-y: auto;
}

.team-option-content {
  padding: 4px 0;
  min-height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.team-option-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 8px;
}

.team-name {
  font-weight: 600;
  color: #333;
  flex: 1;
  text-align: left;
  margin-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-response-count {
  font-size: 12px;
  color: #626262;
  font-weight: 400;
  margin-left: 8px;
  white-space: nowrap;
}

.selected-team {
  background-color: rgba(50, 194, 213, 0.1) !important;
}

.no-teams-found {
  padding: 16px;
  text-align: center;
  color: #909399;
  font-size: 13px;
  font-style: italic;
}

.drop-down-container {
  margin-left: 12px;
  height: 40px;
  border-radius: 4px;
  padding: 0 8px 0 12px;
}

.drop-down-container.active {
  margin-left: 10px;
  background-color: rgba(#32C2D5, 0.1);
  padding: 0 6px 0 10px;
}

.text-drop-down {
  color: #00ACC1;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  
  .aggregation-indicator {
    margin-left: 6px;
    opacity: 0.7;
    vertical-align: text-bottom;
  }
}

.filtered-indicator {
  color: #32c2d5;
  font-size: 14px;
  font-weight: 600;
}

.aggregation-info-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #f0fafb;
  border: 1px solid #32c2d5;
  border-radius: 4px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #00ACC1;
  
  i {
    font-size: 16px;
  }
}
</style>
<style lang="scss">
#questionsCustom #questions_form_modal {
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-menu {
    background-color: transparent;
  }
  .el-date-editor .el-range-separator {
    width: 6%;
  }
  .el-form-item {
    margin-bottom: 12px;
  }
  .el-form-item__error {
    font-size: 10px;
    padding-top: 0px;
  }
  .el-form-item__label {
    line-height: 40px;
  }
}
#questionsCustom i.el-dialog__close.el-icon.el-icon-close {
  font-size: 26px;
  margin-top: 12px;
}
#questionsCustom i.el-select__caret.el-input__icon.el-icon-arrow-up {
  color: #000;
  font-size: 16px;
  font-weight: bold;
}
#questionsCustom i.el-icon-caret-right {
  margin-top: 20px;
}
#question .el-form-item__label {
  line-height: 52px;
}
#question .el-input__suffix {
  right: 12px;
}
#openEndedTable div.el-table__body-wrapper.is-scrolling-none {
  height: 470px !important;
}

/* Question Meta Badges */
.question-meta-badges {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
}

.question-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.badge-multiple-choice {
  background-color: rgba(33, 150, 243, 0.15);
  color: rgba(13, 71, 161, 0.9);
}

.badge-yes-no {
  background-color: rgba(76, 175, 80, 0.15);
  color: rgba(27, 94, 32, 0.9);
}

.badge-scale {
  background-color: rgba(156, 39, 176, 0.15);
  color: rgba(74, 20, 140, 0.9);
}

.badge-text-area {
  background-color: rgba(158, 158, 158, 0.15);
  color: rgba(66, 66, 66, 0.9);
}

.badge-follow-up {
  background-color: rgba(255, 152, 0, 0.15);
  color: rgba(230, 81, 0, 0.9);
}

.badge-default {
  background-color: rgba(158, 158, 158, 0.15);
  color: rgba(97, 97, 97, 0.9);
}

/* Power Skill Badge */
.power-skill-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: rgba(247, 117, 17, 0.15);
  color: rgba(183, 69, 0, 0.9);
  line-height: 1.2;
  white-space: nowrap;
}

/* Frequency Tags */
.frequency-tag {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 1.3;
  white-space: nowrap;
}

.tag-biannual {
  background-color: rgba(239, 108, 0, 0.15);
  color: rgba(191, 54, 12, 0.9);
}

.tag-yearly {
  background-color: rgba(0, 150, 136, 0.15);
  color: rgba(0, 77, 64, 0.9);
}

.tag-follow-up {
  background-color: rgba(158, 158, 158, 0.15);
  color: rgba(97, 97, 97, 0.9);
}

.tag-default {
  background-color: rgba(84, 110, 122, 0.15);
  color: rgba(38, 50, 56, 0.9);
}
</style>
